import { getCurrentLanguage } from './language';

export const editorTranslationsEn: Record<string, string> = {
  // Вид линии (docs/editing/plan.md §4.2.1)
  'Линия объекта': 'Feature line',
  'Вид линии': 'Line style',
  'Сплошная': 'Solid',
  'Пунктир': 'Dashed',
  'Углы': 'Corners',
  'Прямые': 'Sharp',
  'Скошенные': 'Beveled',
  'Скруглённые': 'Rounded',
  'Начало': 'Start',
  'Конец': 'End',
  'Стрелка': 'Arrow',
  'Открытая стрелка': 'Open arrow',
  'Черта': 'Bar',
  'Паттерн': 'Pattern',
  'Стрелки': 'Arrows',
  'Шевроны': 'Chevrons',
  'Как в слое': 'As in layer',
  'Развернуть направление': 'Reverse direction',
  'Окончания и скругление недоступны для тайловых слоёв: в тайле нет линий целиком.':
    'End caps and corner rounding are unavailable for tiled layers: tiles do not hold whole lines.',
  'Стрелки с линией': 'Arrows with shafts',
  'Промежуток': 'Gap',
  'В толщинах линии': 'In line widths',
  'Скругление': 'Rounding',
  'как в слое': 'as in layer',
  'Применится ко всем выбранным объектам: {count}': 'Applies to all selected features: {count}',
  // Поиск по карте и объектам
  'Поиск': 'Search',
  'Очистить': 'Clear',
  'Объекты проекта': 'Project features',
  'Места и POI': 'Places & POIs',
  'Не удалось выполнить поиск': 'Search failed',
  // Типы мест (geo_places) — обратный перевод для EN-интерфейса
  'город': 'city',
  'село': 'village',
  'деревня': 'hamlet',
  'район': 'district',
  'местность': 'locality',
  'остров': 'island',
  'страна': 'country',
  'регион': 'region',
  'провинция': 'province',
  'нац. парк': 'national park',
  'заповедник': 'nature reserve',
  'охраняемая территория': 'protected area',
  'лес': 'forest',
  'парк': 'park',
  'военный объект': 'military',
  'университет': 'university',
  'станция': 'station',
  'метро': 'subway',
  'остановка': 'bus stop',
  'музей': 'museum',
  'кафе': 'cafe',
  'ресторан': 'restaurant',
  'Мне нужна карта в тёмных тонах...': 'I need a dark map...',
  'Добавить значение': 'Add value',
  'Добавить': 'Add',
  'Кликните для переименования': 'Click to rename',
  'Без раскраски': 'No data-driven colors',
  'Обложка': 'Cover',
  '**Жирный** *курсив* [ссылка](url)': '**Bold** *italic* [link](url)',
  'Удалить параметр': 'Delete property',
  'Мой стиль': 'My style',
  'Параметр…': 'Property…',
  'Как в списке слоя': 'As shown in the layer list',
  'Выберите поле': 'Select field',
  'Загрузить иконку (PNG, JPG, WebP, SVG)': 'Upload icon (PNG, JPG, WebP, SVG)',
  'Описание слоя (поддерживает markdown)...': 'Layer description (Markdown supported)...',
  'от': 'from',
  'до': 'to',
  'Выбор цвета обводки точки с превью': 'Choose preview point stroke color',
  'Выбор цвета фона свободной формы': 'Choose freeform background color',
  'Цвет на остановке зума': 'Color at zoom stop',
  'Отключить изменение по зуму': 'Disable zoom-based styling',
  'Описание стиля': 'Style description',
  'Опишите желаемый стиль карты словами (например: «тёмная карта с яркой водой и оранжевыми дорогами»)': 'Describe the desired map style (for example: “a dark map with bright water and orange roads”)',
  'Генерирую...': 'Generating...',
  'Сгенерировать стиль': 'Generate style',
  'Название темы': 'Theme name',
  'Рекомендуемое название:': 'Suggested name:',
  'Сохранить тему': 'Save theme',
  'Раскраска по параметру': 'Color by property',
  'Добавьте поля в схему данных ниже, чтобы раскрашивать объекты по значению.': 'Add fields to the data schema below to color features by value.',
  'Без раскраски (один цвет)': 'No data-driven colors (single color)',
  'У объектов нет значений для этого поля. Заполните поле в карточке каждого объекта.': 'Features have no values for this field. Fill it in for each feature.',
  'Палитра цветов': 'Color palette',
  'Своя палитра': 'Custom palette',
  'Снять выбор': 'Clear selection',
  'Добавить файл': 'Add file',
  'Параметры объектов': 'Feature properties',
  'Задайте параметры, которые можно заполнять для объектов этого слоя.': 'Define properties that can be filled in for features in this layer.',
  'Добавить параметр': 'Add property',
  'Высота 3D (extrusion)': '3D height (extrusion)',
  'Добавьте в схему слоя числовые параметры — здесь можно выбрать поле высоты вместо выражения в paint.': 'Add numeric properties to the layer schema to use a height field instead of a paint expression.',
  'Высота по параметру': 'Height by property',
  'Параметр не выбран': 'No property selected',
  'Коэффициент высоты': 'Height multiplier',
  'Значение параметра умножается на коэффициент (например, 3 для этажей).': 'The property value is multiplied by this number (for example, 3 for floors).',
  'Fallback высота (м)': 'Fallback height (m)',
  'Высота, если значение параметра отсутствует или не положительное.': 'Height used when the property is missing or not positive.',
  'Кол-во': 'Count',
  'Проценты': 'Percent',
  'Вид': 'Display',
  'Диапазон': 'Range',
  'Таймлайн': 'Timeline',
  'Диапазонов': 'Ranges',
  'Показывать гистограмму': 'Show histogram',
  'Свои границы классов': 'Custom class breaks',
  'Сбросить на равные интервалы': 'Reset to equal intervals',
  'Фильтры для публичной карты': 'Public map filters',
  'Добавьте в схему слоя параметры типа «строка», «число», «логический», «массив» или «выбор», чтобы настроить фильтры для публичной карты.': 'Add string, number, boolean, array, or select properties to the layer schema to configure public map filters.',
  'Фильтры позволяют пользователям отбирать объекты по параметрам на публичной карте.': 'Filters let visitors select features by property on the public map.',
  'Выберите параметр': 'Select a property',
  'Добавить фильтр': 'Add filter',
  'У объектов нет значений для этого поля. Заполните поле в карточке каждого объекта или задайте варианты в схеме параметра.': 'Features have no values for this field. Fill it in for each feature or define options in the property schema.',
  'Иконка для значения': 'Icon per value',
  'У части объектов своя иконка — она меняется в карточке объекта.':
    'Some features have their own icon — change it in the feature card.',
  'Выбрано объектов:': 'Selected features:',
  '. Изменения параметров применяются ко всем выбранным.': '. Property changes apply to all selected features.',
  'Параметры объекта': 'Feature properties',
  'Стиль изображения': 'Image style',
  'Значения — по первому выбранному объекту; изменение применится ко всем выбранным.': 'Values are shown for the first selected feature; changes apply to all selected features.',
  'Заменить файл': 'Replace file',
  'Добавить изображение в слой': 'Add image to layer',
  'Расположение': 'Position',
  'Перемещайте изображение на карте мышью. Alt+колесо — масштаб. Shift+колесо — поворот.': 'Drag the image on the map. Alt+wheel scales it; Shift+wheel rotates it.',
  'Изображения в слое': 'Images in layer',
  'В слое:': 'In layer:',
  '. Выберите объект в списке слоя или на карте, чтобы заменить файл или править подпись.': '. Select a feature in the layer list or on the map to replace the file or edit its label.',
  'Добавить стиль из другого проекта': 'Add style from another project',
  'Стиль будет скопирован в этот проект как отдельная запись. Изменения в копии не затронут оригинал.': 'The style will be copied into this project. Changes to the copy will not affect the original.',
  'Не удалось загрузить список стилей.': 'Could not load the style list.',
  'Нет стилей для импорта': 'No styles to import',
  'В других проектах пока нет сохранённых стилей карты, или все они уже в этом проекте.': 'Other projects have no saved map styles, or all of them are already in this project.',
  'Поле для подписи': 'Label field',
  'Отдельное поле': 'Separate field',
  'Настройки для публичной карты': 'Public map settings',
  'Показывать слой на публичной карте': 'Show layer on public map',
  'Отображать в панели слоёв': 'Show in layers panel',
  'Тумблер включения/выключения': 'Visibility toggle',
  'По умолчанию:': 'Default:',
  'Включён': 'On',
  'Выключен': 'Off',
  'Иконка слоя': 'Layer icon',
  'Без иконки': 'No icon',
  'Загруженная иконка': 'Uploaded icon',
  'Использовать символ точек': 'Use point symbol',
  'Загрузить...': 'Upload...',
  'Показывать легенду': 'Show legend',
  'Показывать превью': 'Show preview',
  'Превью доступно только если в схеме слоя есть параметр типа «Обложка».': 'Preview is available only when the layer schema has a Cover property.',
  'Описание слоя': 'Layer description',
  'Объекты кликабельны': 'Features are clickable',
  'Высота (м)': 'Height (m)',
  'Масштаб': 'Scale',
  'Поворот (°): X, Y, Z': 'Rotation (°): X, Y, Z',
  'Авто': 'Auto',
  'бинов': 'bins',
  'zoom-зависимый': 'zoom-based',
  'Точка с превью': 'Preview point',
  'Форма': 'Shape',
  'Якорь превью': 'Preview anchor',
  'Параметр-обложка': 'Cover property',
  'Добавьте параметр типа «Обложка» в схему данных слоя ниже.': 'Add a Cover property to the layer data schema below.',
  'Без изображения': 'No image',
  'Размер (радиус)': 'Size (radius)',
  'Толщина обводки (0 = без обводки)': 'Stroke width (0 = no stroke)',
  'Цвет обводки берётся из палитры «Раскраска по параметру».': 'Stroke color comes from the Color by property palette.',
  'Показать фон': 'Show background',
  'Ничего не найдено': 'Nothing found',
  'зум': 'zoom',
  'Изменение по зуму': 'Zoom-based styling',
  'Отключить': 'Disable',
  'База:': 'Base:',
  'Добавить точку': 'Add stop',
  'Новый слой {number}': 'New layer {number}',
  'Растровый слой {number}': 'Raster layer {number}',
  'Новый 3D-слой {number}': 'New 3D layer {number}',
  'уникальное значение': 'unique value',
  'уникальных значения': 'unique values',
  'уникальных значений': 'unique values',
  'Свои цвета по значениям': 'Custom colors by value',
  'Цвета по значениям': 'Colors by value',
  'числа': 'numbers',
  'строки': 'strings',
  'изображение': 'image',
  'изображений': 'images',
  'Настроить изменение по зуму (на карте применяется плавно через text-translate)': 'Configure zoom-based styling (applied smoothly on the map with text-translate)',
  'Убрать изменение по зуму': 'Remove zoom-based styling',
  'Цвет диапазона {number}': 'Range {number} color',
  'Выбор цвета: {label}': 'Choose color: {label}',
  'Изменить ширину панели слоёв': 'Resize layers panel',
  'Объект': 'Feature',
  'Объект {number}': 'Feature {number}',
  'Изображение {number}': 'Image {number}',
  'Слой {name}': 'Layer {name}',
  'Объекты ({count})': 'Features ({count})',
  'Точка': 'Point',
  'Линия': 'Line',
  'Полигон': 'Polygon',
  'Выбор': 'Select',
  'Свободная линия': 'Freehand line',
  'Круг': 'Circle',
  'Прямоугольник': 'Rectangle',
  'Комментарий': 'Comment',
  'Импорт GeoJSON': 'Import GeoJSON',
  'Импорт OSM зданий': 'Import OSM buildings',
  'Название проекта': 'Project name',
  'Без названия': 'Untitled',
  'Загрузка...': 'Loading...',
  'Импорт данных': 'Import data',
  'Загрузите геоданные (GeoJSON, CSV, XLSX, KML/KMZ, Shapefile, GeoPackage, GPX), 3D-модели (gltf/glb) или фотографии. Фотографии можно импортировать как точки с превью или растровые оверлеи.':
    'Upload geodata (GeoJSON, CSV, XLSX, KML/KMZ, Shapefile, GeoPackage, GPX), 3D models (gltf/glb), or photos. Photos can be imported as points with previews or raster overlays.',
  'Закрыть': 'Close',
  'Импортировать': 'Import',
  'Чтение GPS-данных из фотографий...': 'Reading GPS data from photos...',
  'Импортировать с привязкой к GPS-координатам': 'Use GPS coordinates',
  '{withGps} из {total} фото содержат GPS (прочитано в браузере)': '{withGps} of {total} photos contain GPS data (read in the browser)',
  '· для HEIC/HEIF координаты дополнительно проверяются на сервере при загрузке': '· HEIC/HEIF coordinates are additionally checked on the server during upload',
  'HEIC/HEIF: GPS читается на сервере при загрузке; если координаты есть в метаданных, точки встанут по ним': 'HEIC/HEIF: GPS data is read on the server during upload; points will use coordinates found in metadata',
  'Ни одно из выбранных фото не содержит GPS-данных. Все точки будут размещены в центре текущей области карты.': 'None of the selected photos contain GPS data. All points will be placed in the center of the current map view.',
  '{count} фото без GPS — будут размещены в центре слоя:': '{count} photos without GPS will be placed in the center of the layer:',
  'Перетащите файлы сюда': 'Drop files here',
  'Геоданные: .geojson, .csv, .xlsx, .kml, .kmz, .gpkg, .gpx, .zip (Shapefile, MapHub)': 'Geodata: .geojson, .csv, .xlsx, .kml, .kmz, .gpkg, .gpx, .zip (Shapefile, MapHub)',
  'Геоданные: .geojson, .csv, .xlsx, .kml, .kmz, .gpkg, .gpx, .zip (Shapefile, MapHub) или файлы Shapefile вместе (.shp, .shx, .dbf, .prj)':
    'Geodata: .geojson, .csv, .xlsx, .kml, .kmz, .gpkg, .gpx, .zip (Shapefile, MapHub) or Shapefile parts together (.shp, .shx, .dbf, .prj)',
  // Причины из `importSelectionProblem` (importUtils.ts): доходят до et() переменной, паритет их не видит.
  'Shapefile состоит из нескольких файлов: выберите вместе .shp, .shx, .dbf и .prj или загрузите их одним ZIP-архивом.':
    'A Shapefile consists of several files: select .shp, .shx, .dbf and .prj together, or upload them as one ZIP archive.',
  'Не хватает файлов Shapefile «{name}»: {missing}. Выберите их вместе с .shp или загрузите один ZIP-архив.':
    'Shapefile “{name}” is missing {missing}. Select them together with the .shp, or upload one ZIP archive.',
  'Файл «{name}» выбран дважды — возможно, из разных папок. Оставьте по одному файлу каждой части Shapefile.':
    'The file “{name}” is selected twice, perhaps from different folders. Keep one file per Shapefile part.',
  'Формат MapInfo пока не поддерживается. Сохраните слой как GeoPackage, Shapefile или GeoJSON (в MapInfo или QGIS — «Сохранить как»).':
    'MapInfo files are not supported yet. Save the layer as GeoPackage, Shapefile or GeoJSON (“Save As” in MapInfo or QGIS).',
  'Старый формат Excel (.xls) не поддерживается. Сохраните таблицу как XLSX или CSV.':
    'Legacy Excel (.xls) is not supported. Save the sheet as XLSX or CSV.',
  'Чертежи CAD (.dxf, .dwg) не поддерживаются. Экспортируйте объекты в GeoJSON или Shapefile с системой координат.':
    'CAD drawings (.dxf, .dwg) are not supported. Export the features to GeoJSON or Shapefile with a coordinate system.',
  'Построчный GeoJSON пока не поддерживается. Сохраните данные как обычный GeoJSON (FeatureCollection).':
    'Line-delimited GeoJSON is not supported yet. Save the data as regular GeoJSON (FeatureCollection).',
  'Геоданные и 3D-модели загружаются по одному файлу, фотографии — пачкой. Выберите один файл с данными.':
    'Geodata and 3D models are uploaded one file at a time, photos in batches. Select a single data file.',
  'У файла нет расширения — не понять, что в нём. Добавьте расширение (.geojson, .csv, .gpkg …) или сохраните данные в поддерживаемом формате.':
    'The file has no extension, so its format is unknown. Add an extension (.geojson, .csv, .gpkg …) or save the data in a supported format.',
  'Формат «{ext}» не поддерживается. Геоданные: GeoJSON, CSV, XLSX, KML/KMZ, Shapefile, GeoPackage, GPX; 3D: glTF/GLB; фото: JPG, PNG, WebP, HEIC.':
    'The “{ext}” format is not supported. Geodata: GeoJSON, CSV, XLSX, KML/KMZ, Shapefile, GeoPackage, GPX; 3D: glTF/GLB; photos: JPG, PNG, WebP, HEIC.',  'Фотографии: .jpg, .jpeg, .png, .webp': 'Photos: .jpg, .jpeg, .png, .webp',
  '3D-модели: .gltf, .glb': '3D models: .gltf, .glb',
  'Добавить файлы к текущему выбору': 'Add files to the current selection',
  'Выбрать файл для импорта': 'Choose a file to import',
  'Нажмите для выбора файла': 'Click to choose a file',
  'Можно кликнуть сюда или перенести файлы, чтобы добавить к выбору': 'Click here or drop more files to add them to the selection',
  'Файл': 'File',
  '{count} файлов': '{count} files',
  '{count} файлов выбрано': '{count} files selected',
  'Загрузка... {current} / {total}': 'Uploading... {current} / {total}',
  'Импортировано объектов: {count}': 'Features imported: {count}',
  'Пропущено объектов: {count}': 'Features skipped: {count}',
  'Пропущено строк таблицы: {count}': 'Table rows skipped: {count}',
  'Объект №{number}: {reason}': 'Feature #{number}: {reason}',
  'Строка {row}: {reason}': 'Row {row}: {reason}',
  'Лист «{sheet}», строка {row}: {reason}': 'Sheet “{sheet}”, row {row}: {reason}',
  '…и ещё {count}': '…and {count} more',
  'Изображения добавлены в выбранный слой': 'Images added to the selected layer',
  'Модель добавлена в выбранный слой': 'Model added to the selected layer',
  'Создано слоёв: {count}': 'Layers created: {count}',
  'Импорт завершен с предупреждениями: {count}': 'Import completed with {count} warnings:',
  '{count} фото без GPS размещено в центре слоя': '{count} photos without GPS were placed in the center of the layer',
  'Выбрано {count} фото. Как импортировать?': '{count} photos selected. How should they be imported?',
  'Точки с превью': 'Points with previews',
  'Каждое фото — объект на карте с изображением': 'Each photo becomes a map feature with an image',
  'Растровые оверлеи': 'Raster overlays',
  'Каждое фото — отдельный слой на карте': 'Each photo becomes a separate map layer',
  'OSM здания': 'OSM buildings',
  'Укажите корректный bbox (west,south,east,north)': 'Enter a valid bbox (west,south,east,north)',
  'Выберите область на карте и импортируйте здания из OpenStreetMap': 'Select a map area and import buildings from OpenStreetMap',
  'Источник области': 'Area source',
  'Текущая область на карте': 'Current map view',
  'Ввести вручную': 'Enter manually',
  'Текущая область на карте:': 'Current map view:',
  'Нет данных области карты — сдвиньте карту или выберите «Ввести вручную».': 'Map bounds are unavailable — move the map or choose “Enter manually”.',
  'Введите bbox: west, south, east, north': 'Enter bbox: west, south, east, north',
  'Некорректный формат. Используйте: west,south,east,north': 'Invalid format. Use: west,south,east,north',
  '✓ Область:': '✓ Area:',
  'Примечание:': 'Note:',
  'Импорт может занять время в зависимости от размера области. Большие области могут содержать тысячи зданий.': 'Import time depends on the area size. Large areas may contain thousands of buildings.',
  'Чтение данных...': 'Reading data...',
  'Добавить на карту': 'Add to map',
  'Нет доступа к геолокации. Разрешите доступ в настройках браузера и macOS.': 'Location access is denied. Allow it in your browser and macOS settings.',
  'Не удалось определить координаты. Включите Wi‑Fi и службы геолокации.': 'Could not determine your location. Turn on Wi-Fi and location services.',
  'Геолокация не ответила вовремя. Попробуйте ещё раз.': 'Location timed out. Please try again.',
  'Не удалось определить местоположение.': 'Could not determine your location.',
  'Карта ещё не готова': 'The map is not ready yet',
  'Показано приблизительное место по IP: на компьютере точная геолокация через браузер часто недоступна.': 'Showing an approximate IP-based location. Precise browser location is often unavailable on desktop.',
  'Карта недоступна': 'Map unavailable',
  'Приблизительное местоположение по IP': 'Approximate IP-based location',
  'Ваше местоположение': 'Your location',
  'Навигация по карте': 'Map navigation',
  'Приблизить': 'Zoom in',
  'Отдалить': 'Zoom out',
  'Перетащите для поворота карты; короткий клик — сброс на север и наклон': 'Drag to rotate the map; click to reset north and pitch',
  'Перетащите для поворота карты; короткий клик — сброс на север': 'Drag to rotate the map; click to reset north',
  'Геолокация': 'Geolocation',
  'Показать моё местоположение': 'Show my location',
  'Стиль карты': 'Map style',
  'Настроить свой стиль': 'Create custom style',
  'Сгенерировать свой стиль': 'Generate custom style',
  'Добавить из другого проекта': 'Add from another project',
  'Сохранить': 'Save',
  'Сохранить стиль': 'Save style',
  'Редактировать стиль': 'Edit style',
  'Удалить стиль': 'Delete style',
  'Шрифт на карте': 'Map font',
  'Удалить стиль?': 'Delete style?',
  'Свой стиль': 'Custom style',
  'Стиль «{name}» будет удалён. Это действие нельзя отменить.': '“{name}” will be deleted. This action cannot be undone.',
  'Удалить': 'Delete',
  'Показывать зум и компас': 'Show zoom and compass',
  'Запретить наклон и поворот карты': 'Disable map pitch and rotation',
  'Позиция камеры': 'Camera position',
  'Долгота': 'Longitude',
  'Широта': 'Latitude',
  'Наклон': 'Pitch',
  'Поворот': 'Bearing',
  'Зум': 'Zoom',
  'Мин. зум': 'Min zoom',
  'Макс. зум': 'Max zoom',
  'Сохранение...': 'Saving...',
  'Обновить позицию карты': 'Update map position',
  'Сохранить позицию карты': 'Save map position',
  'Сохранённая позиция используется как начальный вид при открытии проекта.': 'The saved position is used as the initial view when the project opens.',
  'Цвет области за пределами изображения': 'Color outside the image area',
  'Отступ за край изображения в долях его размера. 0 — нельзя выйти за край, 0.5 — можно отойти на половину ширины/высоты (по умолчанию).': 'Padding beyond the image edge as a fraction of its size. 0 prevents panning beyond the edge; 0.5 allows half the image width or height (default).',
  'Цвет фона': 'Background color',
  'Справка: цвет фона': 'Help: background color',
  'Выбор цвета фона подложки': 'Choose map background color',
  'HEX цвета фона подложки': 'Map background HEX color',
  'Фоновое изображение': 'Background image',
  'Фон карты': 'Map background',
  'Заменить': 'Replace',
  'Загрузить фоновое изображение': 'Upload background image',
  'Нажмите для загрузки': 'Click to upload',
  'Ограничение панорамирования': 'Panning bounds',
  'Справка: ограничение панорамирования': 'Help: panning bounds',
  'Отступ ограничения панорамирования': 'Panning bounds padding',
  'На главную': 'Back to dashboard',
  'Кликните для редактирования': 'Click to edit',
  'Слои': 'Layers',
  'Добавить слой': 'Add layer',
  '📄 Новый слой': '📄 New layer',
  '🗺️ Растровый слой': '🗺️ Raster layer',
  '📦 Новый 3D-слой': '📦 New 3D layer',
  '🔌 Интеграция': '🔌 Integration',
  'Нет слоёв': 'No layers',
  'Добавьте первый слой через кнопку «+» в заголовке панели.': 'Add your first layer with the “+” button in the panel header.',
  'Центрировать на объекте': 'Zoom to feature',
  'Показать объект': 'Show feature',
  'Скрыть объект': 'Hide feature',
  'Свернуть': 'Collapse',
  'Развернуть': 'Expand',
  'Центрировать на слое': 'Zoom to layer',
  'Разблокировать слой': 'Unlock layer',
  'Заблокировать слой': 'Lock layer',
  'Скрыть слой': 'Hide layer',
  'Показать слой': 'Show layer',
  'Нет объектов': 'No features',
  'Библиотека': 'Library',
  'Шрифты': 'Fonts',
  'Возвращаю шрифт': 'Restoring font',
  'Поддерживаются форматы TTF и OTF': 'TTF and OTF formats are supported',
  'Ошибка загрузки': 'Upload failed',
  'Загрузить': 'Upload',
  'Возвращаю шрифт {font}': 'Restoring {font}',
  'Удалить шрифт «{font}»?': 'Delete “{font}”?',
  'Владелец': 'Owner',
  'Редактор': 'Editor',
  'Просмотр': 'Viewer',
  '(ожидает)': '(pending)',
  'Удалить доступ': 'Remove access',
  'Неверный пароль. Проверьте ввод и попробуйте ещё раз.': 'Incorrect password. Check it and try again.',
  'Не удалось передать владение': 'Could not transfer ownership',
  'Вы уверены? После передачи вы потеряете права владельца.': 'Are you sure? You will lose owner permissions after the transfer.',
  'Подтвердите пароль': 'Confirm your password',
  'Текущий пароль от аккаунта': 'Current account password',
  'Подтвердить': 'Confirm',
  'Отмена': 'Cancel',
  'Выбрать нового владельца...': 'Select a new owner...',
  'Передать': 'Transfer',
  'Не удалось добавить участника': 'Could not add member',
  'Доступ к проекту': 'Project access',
  'Пригласить по email': 'Invite by email',
  'Пригласить': 'Invite',
  'Свойства': 'Properties',
  '3D-модель': '3D model',
  'Изображение': 'Image',
  'Слой': 'Layer',
  'Карта': 'Map',
  'Сохраняем…': 'Saving…',
  'Сохранено': 'Saved',
  'Ошибка сохранения': 'Save failed',
  'Поделиться': 'Share',
  'Дублировать объект': 'Duplicate feature',
  'Удалить объект': 'Delete feature',
  'Удалить объекты ({count})': 'Delete features ({count})',
  'Дублировать объекты ({count})': 'Duplicate features ({count})',
  'Дублировать слой': 'Duplicate layer',
  'Дублировать в другой проект': 'Duplicate to another project',
  'Дублировать в проект': 'Duplicate to project',
  'Других проектов нет': 'No other projects',
  'Не удалось загрузить проекты': 'Failed to load projects',
  'Удалить слой': 'Delete layer',
  'Скопировать': 'Copy',
  'Управление доступом к проекту и публикация карты.': 'Manage project access and publish the map.',
  'Доступ': 'Access',
  'Публикация': 'Publishing',
  'Публичный доступ': 'Public access',
  'Любой, у кого есть ссылка, сможет видеть карту': 'Anyone with the link can view the map',
  'Публичная ссылка': 'Public link',
  // Бренд на публичной карте — фича тарифа (docs/billing/plan.md §2)
  'Скрыть лого «Слоя» на публичной карте': 'Hide the Sloy logo on the public map',
  'Опубликованная карта без бренда «Слоя»': 'The published map without Sloy branding',
  'Доступно в тарифе PRO': 'Available on the PRO plan',
  'Ссылка на карту': 'Map link',
  'Встраивание на сайт': 'Embed on a website',
  'HTML-код для вставки': 'Embed HTML',
  'Настройки интерфейса карты': 'Map interface settings',
  'Панель фильтров': 'Filters panel',
  'Показывать панель слоёв и фильтров': 'Show the layers and filters panel',
  'Стиль интерфейса': 'Interface style',
  'Светлая / тёмная': 'Light / dark',
  'Тема интерфейса карты': 'Map interface theme',
  'Шрифты интерфейса': 'Interface fonts',
  'Загрузите шрифты в библиотеку, чтобы использовать их в интерфейсе карты': 'Upload fonts to the library to use them in the map interface',
  'Заголовки': 'Headings',
  'Текст': 'Text',
  'Комментарии': 'Comments',
  'Разрешить посетителям оставлять комментарии': 'Allow visitors to leave comments',
  'Публичная карта: добавление маркеров с текстом или реакцией': 'Public map: add markers with text or a reaction',
  'Показывать комментарии посетителям': 'Show comments to visitors',
  'Загрузка и отображение маркеров на публичной карте': 'Load and display markers on the public map',
  'Разрешить ответы на комментарии': 'Allow replies to comments',
  'Только при включённом показе комментариев': 'Only when comments are visible',
  'Название': 'Name',
  'Название в списке': 'Name in list',
  'Заголовок карточки': 'Card title',
  'Подпись на карте': 'Map label',
  'Подпись': 'Label',
  'Выбрано объектов: {count}. Изменения параметров применяются ко всем выбранным.': '{count} features selected. Property changes apply to all selected features.',
  'Выделено {count}': '{count} selected',
  'Нет свойств': 'No properties',
  'Свойства объекта недоступны для слоёв из векторных тайлов.': 'Feature properties are unavailable for vector tile layers.',
  'Тип геометрии': 'Geometry type',
  'Иконка': 'Icon',
  'Параметр': 'Property',
  'Тип визуализации': 'Visualization type',
  'Название слоя': 'Layer name',
  'Диапазон зума': 'Zoom range',
  'Карточка объекта': 'Feature card',
  'Показывать координаты': 'Show coordinates',
  'Кнопка «Поделиться»': 'Share button',
  'Подписи': 'Labels',
  'Угол поворота': 'Rotation angle',
  'Угол обзора': 'Field of view',
  '{title} · Shift — шаг {step}°': '{title} · Shift — {step}° steps',
  'Изменение по зуму включено': 'Zoom-based styling is enabled',
  'Настроить изменение по зуму': 'Configure zoom-based styling',
  'Генерируем тайлы публичной карты…': 'Generating public map tiles…',
  'Тайлы публичной карты готовы': 'Public map tiles are ready',
  'Изменения сохранены — тайлы обновятся автоматически': 'Changes saved — tiles will update automatically',
  'Тайлы публичной карты': 'Public map tiles',
  'Тип карты': 'Map type',
  'Описание проекта': 'Project description',
  'Поддерживается markdown': 'Markdown supported',
  'Показывается в панели опубликованной карты под названием проекта.':
    'Shown in the published map panel under the project name.',
  'Не удалось сохранить описание проекта': 'Could not save the project description',
  'Изображение-подложка перенесено из архива': 'The background image was carried over from the archive',
  'Подложка и начальный вид карты перенесены из MapHub':
    'Basemap and initial map view were carried over from MapHub',
  'Карта в MapHub называется «{title}» — имя проекта оставлено прежним':
    'The MapHub map is named “{title}” — the project name was left unchanged',
  'Прогресс': 'Progress',
  'читаем данные...': 'reading data...',
  'генерируем тайлы...': 'generating tiles...',
  'загружаем...': 'uploading...',
  'в очереди': 'queued',
  'ожидает обновления': 'waiting for update',
  'Нет публичных векторных слоёв для генерации тайлов.': 'There are no public vector layers to generate tiles for.',
  'Дополнительные опции': 'Advanced options',
  'Цвет обводки': 'Stroke color',
  'Прозрачность': 'Opacity',
  'Мин. яркость': 'Min brightness',
  'Макс. яркость': 'Max brightness',
  'Насыщенность': 'Saturation',
  'Контраст': 'Contrast',
  'Цвет': 'Color',
  'Радиус': 'Radius',
  'Размытие': 'Blur',
  'Ширина обводки': 'Stroke width',
  'Прозрачность обводки': 'Stroke opacity',
  'Смещение [x,y]': 'Offset [x,y]',
  'Масштаб при наклоне': 'Pitch scale',
  'Выравнивание при наклоне': 'Pitch alignment',
  'Ключ сортировки': 'Sort key',
  'Цвет заливки': 'Fill color',
  'Прозрачность заливки': 'Fill opacity',
  'Цвет обводки (контур)': 'Outline color',
  'Толщина обводки': 'Stroke width',
  'Сглаживание': 'Antialiasing',
  'Якорь смещения': 'Offset anchor',
  'Паттерн (спрайт)': 'Pattern (sprite)',
  'Цвет линии': 'Line color',
  'Ширина': 'Width',
  'Зазор': 'Gap',
  'Смещение': 'Offset',
  'Штрих (массив)': 'Dash array',
  'Градиент (выражение)': 'Gradient (expression)',
  'Окончание линии': 'Line cap',
  'Соединение линий': 'Line join',
  'Предел miter': 'Miter limit',
  'Предел round': 'Round limit',
  'Высота': 'Height',
  'м': 'm',
  'Основание': 'Base',
  'Вертикальный градиент': 'Vertical gradient',
  'Вес': 'Weight',
  'Интенсивность': 'Intensity',
  'Цвет (выражение)': 'Color (expression)',
  'Размер иконки': 'Icon size',
  'Якорь иконки': 'Icon anchor',
  'Смещение иконки [x,y]': 'Icon offset [x,y]',
  'Поворот иконки': 'Icon rotation',
  'Отступ иконки': 'Icon padding',
  'Наложение точек': 'Point overlap',
  'Наложение подписей': 'Label overlap',
  'Если не хватает места': 'When there is no room',
  'Скрывать при наложении': 'Hide when overlapping',
  'Показывать всегда': 'Always show',
  'Своя настройка': 'Custom setting',
  'Задано вручную. Выберите режим, чтобы заменить.': 'Set manually. Pick a mode to replace it.',
  'Если точки стоят тесно, часть прячется. Какие останутся, решает порядок объектов.': 'When points are crowded, some are hidden. Feature order decides which stay.',
  'Видны все точки, даже если наезжают друг на друга.': 'All points are shown, even when they overlap.',
  'Скрывать при наложении подписей': 'Hide when overlapping labels',
  'Если подписи наезжают друг на друга, часть прячется. Пока точки скрываются при наложении, подписи уступают и им.': 'When labels overlap each other, some are hidden. While points hide on overlap, labels give way to them too.',
  'Если подписи наезжают друг на друга, часть прячется. На точки подписи ложатся спокойно.': 'When labels overlap each other, some are hidden. Labels may lie over points.',
  'Подписи видны у всех видимых точек, даже внахлёст. Скрытая точка прячет и свою подпись.': 'Labels are shown for all visible points, even overlapping. A hidden point hides its label too.',
  'Видны все подписи, даже если наезжают друг на друга.': 'All labels are shown, even when they overlap.',
  'Скрывать точку целиком': 'Hide the whole point',
  'Точка и подпись появляются только вместе.': 'The point and its label appear only together.',
  'Оставлять точку без подписи': 'Keep the point without its label',
  'Подпись пропадёт первой, точка останется.': 'The label is hidden first, the point stays.',
  'Оставлять подпись без точки': 'Keep the label without its point',
  'Точка пропадёт первой, подпись останется.': 'The point is hidden first, the label stays.',
  'Выравн. при наклоне': 'Pitch alignment',
  'Выравн. при повороте': 'Rotation alignment',
  'Шрифт': 'Font',
  'Размер текста': 'Text size',
  'Макс. ширина': 'Max width',
  'Высота строки': 'Line height',
  'Межбуквенный': 'Letter spacing',
  'Якорь текста': 'Text anchor',
  'Поворот текста': 'Text rotation',
  'Выравнивание текста': 'Text justification',
  'Отступ текста': 'Text padding',
  'Трансформация текста': 'Text transform',
  'Выравн. текста (наклон)': 'Text pitch alignment',
  'Выравн. текста (поворот)': 'Text rotation alignment',
  'Переменный якорь (массив)': 'Variable anchor array',
  'Радиальное смещение': 'Radial offset',
  'Смещения якорей (выражение)': 'Anchor offsets (expression)',
  'Макс. угол': 'Max angle',
  'Держать текст вертикально': 'Keep text upright',
  'Размещение символа': 'Symbol placement',
  'Интервал символов': 'Symbol spacing',
  'Избегать краёв тайла': 'Avoid tile edges',
  'Порядок по Z': 'Z order',
  'Цвет текста': 'Text color',
  'Прозрачность текста': 'Text opacity',
  'Цвет ореола текста': 'Text halo color',
  'Ширина ореола': 'Halo width',
  'Размытие ореола': 'Halo blur',
  'Якорь смещения текста': 'Text offset anchor',
  'Цвет иконки': 'Icon color',
  'Прозрачность иконки': 'Icon opacity',
  'Цвет ореола иконки': 'Icon halo color',
  'Ширина ореола иконки': 'Icon halo width',
  'Размытие ореола иконки': 'Icon halo blur',
  'Поворот оттенка': 'Hue rotation',
  'Ресемплинг': 'Resampling',
  'Длительность затухания': 'Fade duration',
  'мс': 'ms',
  'Символ': 'Symbol',
  '3D-объект': '3D object',
  'Тепловая карта': 'Heatmap',
  'Растр': 'Raster',
  'Размер': 'Size',
  'Квадрат': 'Square',
  'Пин': 'Pin',
  'Свободная': 'Freehand',
  'Макет Автокрафта': 'Autocraft layout',
  'Генератор': 'Generator',
  'Выберите генератор': 'Select generator',
  'Загружаем поля…': 'Loading fields…',
  'Сгенерировать PDF': 'Generate PDF',
  'Превью': 'Preview',
  'Превью макета': 'Layout preview',
  'Открыть PDF': 'Open PDF',
  // Колонка макета в таблице указателей (docs/wayfinding/plan.md §9.1.8)
  'Открыть': 'Open',
  'Открывается…': 'Opening…',
  'Открыть макет указателя в PDF': 'Open the sign layout as PDF',
  'Макет не открыть: у карты нет ссылки на Автокрафт': 'Cannot open the layout: the map has no Autocraft link',
  'Не удалось открыть макет': 'Could not open the layout',
  'Сторона': 'Side',
  'Обновить превью': 'Refresh preview',
  'Заполнить данные': 'Fill in data',
  'Обновить макет': 'Refresh layout',
  'Обновить макеты всех сторон': 'Refresh layouts of all sides',
  'Страница макета': 'Layout page',
  'Показаны первые {count} страниц; остальные — через выбор страницы.':
    'Showing the first {count} pages; pick any other one in the page selector.',
  'Якорь по страницам макета': 'Anchor per layout page',
  'Сбросить якорь страницы {page}': 'Reset page {page} anchor',
  'Страницы без своего якоря берут общий.': 'Pages without their own anchor use the shared one.',
  'Предыдущая страница': 'Previous page',
  'Следующая страница': 'Next page',
  'Страница {page}': 'Page {page}',
  'Данные макета': 'Layout data',
  'Заполните поля — Автокрафт соберёт PDF для этой точки.': 'Fill in the fields — Autocraft will build a PDF for this point.',
  'Заполните поля — превью макета обновится после ввода.': 'Fill in the fields — the layout preview updates after you edit.',
  'Сторона {side}': 'Side {side}',
  'Страницы макета по сторонам': 'Layout pages by side',
  'Страница стороны {side}': 'Page of side {side}',
  'Общие поля': 'Shared fields',
  'Собранные превью перейдут на новую страницу, когда указатель откроют, или по «Обновить все макеты».':
    'Built previews switch to the new page when the sign is opened, or via “Update all layouts”.',
  'У стороны данные другого генератора — решите, что с ними делать, в панели справа.':
    'This side holds data from another generator — decide what to do with it in the right panel.',
  'Выберите значение': 'Select value',
  'Без картинки': 'No image',
  '{value} (нет в списке)': '{value} (not in the list)',
  // Свой файл во фрейме и наборы групп-массивов Автокрафта
  'Свой файл': 'Own file',
  'Свой файл: {name}': 'Own file: {name}',
  'Свой файл ({ext})': 'Own file ({ext})',
  'Загрузить файл': 'Upload file',
  'Загружаем…': 'Uploading…',
  'Убрать свой файл': 'Remove own file',
  'Допустимы изображения (кроме SVG), PDF и AI': 'Images (except SVG), PDF and AI are allowed',
  'Файл больше {size} МБ': 'The file is larger than {size} MB',
  'Не удалось загрузить файл': 'Could not upload the file',
  'Нет подключения к Автокрафту': 'No Autocraft connection',
  'Вариант': 'Variant',
  'Добавить набор': 'Add set',
  'Дублировать набор': 'Duplicate set',
  'Удалить набор': 'Delete set',
  'Поднять набор': 'Move set up',
  'Опустить набор': 'Move set down',
  // Заполнение формы строкой из данных генератора Автокрафта
  'Заполнить из данных генератора': 'Fill from generator data',
  'Данные генератора не загрузились: {error}': 'Generator data failed to load: {error}',
  'Повторить загрузку': 'Retry',
  'Обновить данные': 'Refresh data',
  'Источник данных': 'Data source',
  'Лист': 'Sheet',
  'В таблице нет строк': 'The table has no rows',
  'Открыть данные по умолчанию': 'Open the default data',
  'Выбрать строку…': 'Choose a row…',
  'Поиск по строкам': 'Search rows',
  'Показаны первые {count} — уточните поиск.': 'Showing the first {count} — refine the search.',
  '{source} · строк: {count}': '{source} · rows: {count}',
  'Новая интеграция': 'New integration',
  'Подключение: {name}': 'Connect: {name}',
  'Заполните параметры. Данные доступа хранятся зашифрованными и наружу не отдаются.': 'Fill in the parameters. Access credentials are stored encrypted and are never exposed.',
  'Выберите готовый сервис или подключите свой API.': 'Choose a ready-made service or connect your own API.',
  'Публичная таблица по ссылке → слой точек. Координаты берутся из колонок.': 'Public spreadsheet via link → point layer. Coordinates are read from columns.',
  'Свой API': 'Custom API',
  'Произвольный REST/GeoJSON эндпоинт. Вы вводите URL и (опц.) доступ.': 'Arbitrary REST/GeoJSON endpoint. Enter the URL and optionally credentials.',
  'Автокрафт': 'Autocraft',
  'Генераторы PDF из проекта Автокрафта → прямоугольные макеты на карте.': 'PDF generators from an Autocraft project → rectangular layouts on the map.',
  'Ссылка на таблицу': 'Spreadsheet link',
  'Доступ открыт «любому, у кого есть ссылка».': 'Access must be open to "anyone with the link".',
  'gid листа (опц.)': 'Sheet gid (optional)',
  'Формат ответа': 'Response format',
  'JSON-массив записей': 'JSON array of records',
  'Путь к массиву (для записей)': 'Array path (for records)',
  'Точечный путь к массиву в JSON, если формат — записи.': 'Dot path to the array in JSON when the format is records.',
  'URL для записи (push, опц.)': 'Write URL (push, optional)',
  'Куда отправлять FeatureCollection слоя при push (двусторонняя sync).': 'Where to send the layer FeatureCollection on push (two-way sync).',
  'Метод записи': 'Write method',
  'Authorization (опц.)': 'Authorization (optional)',
  'Уйдёт заголовком запроса, хранится зашифрованным.': 'Sent as a request header, stored encrypted.',
  'Колонка долготы': 'Longitude column',
  'Колонка широты': 'Latitude column',
  'Поле id (опц., для стабильной синхронизации)': 'Id field (optional, for stable sync)',
  'Назад': 'Back',
  'Подключить': 'Connect',
  'Не удалось создать интеграцию.': 'Could not create integration.',
  'Ссылка на проект': 'Project link',
  'Вставьте полную ссылку, которую сгенерировал Автокрафт. Секрет будет храниться зашифрованно.': 'Paste the full link generated by Autocraft. The secret will be stored encrypted.',
  'Получить генераторы': 'Fetch generators',
  'Доступно генераторов: {count}': '{count} generators available',
  'Создать слой': 'Create layer',
  'Не удалось получить генераторы.': 'Could not fetch generators.',
  'Не удалось подключить Автокрафт.': 'Could not connect Autocraft.',

  // Табличный редактор данных слоя
  'Открыть таблицу': 'Open table',
  'Закрыть таблицу': 'Close table',
  'Экспорт в Excel': 'Export to Excel',
  'ID · не менять': 'ID · do not edit',
  'Ячейку не заполняют': 'Do not fill this cell',
  'Серые ячейки не правят: служебная колонка, поле другой стороны указателя или повтор полей объекта. Импорт их не читает — правьте белые ячейки.':
    'Grey cells are not edited: a service column, a field of another sign side or a repeat of the object fields. Import ignores them — edit the white cells.',
  'Загружаем объекты…': 'Loading objects…',
  'Собираем PDF {done} из {total}': 'Building PDF {done} of {total}',
  'Записываем файл…': 'Writing the file…',
  'Не собрались макеты: {count} — в файле их ячейки пустые':
    'Layouts not built: {count} — their cells in the file are empty',
  'Изменить высоту таблицы': 'Resize table panel',
  'Меню колонки': 'Column menu',
  'По возрастанию': 'Ascending',
  'По убыванию': 'Descending',
  'Поиск в колонке': 'Search in column',
  'Фильтр': 'Filter',
  'Убрать фильтр': 'Remove filter',
  'Сбросить фильтр': 'Clear filter',
  'Сбросить всё': 'Clear all',
  'Изменить поле': 'Edit field',
  'Удалить поле': 'Delete field',
  'Добавить поле': 'Add field',
  'Название поля': 'Field name',
  'Тип поля': 'Field type',
  'Поле с таким именем уже есть': 'A field with this name already exists',
  'Опции (по одной на строку)': 'Options (one per line)',
  'Удаление опции очистит её у всех объектов слоя': 'Removing an option clears it from all layer features',
  'Колонка исчезнет из таблицы и карточек объектов слоя.': 'The column will disappear from the table and feature cards.',
  'Удалить строку': 'Delete row',
  'Удалить строки': 'Delete rows',
  'Нет полей': 'No fields',
  'Добавьте первое поле — колонки таблицы появятся здесь.': 'Add the first field — table columns will appear here.',
  'Загрузка…': 'Loading…',
  'Загружено': 'Loaded',
  'Загрузить все': 'Load all',
  'из': 'of',
  '{shown} из {total}': '{shown} of {total}',
  // Число со словом (`countLabel`): форма «один» и форма «много».
  'объект': 'feature',
  'объектов': 'features',
  'слой': 'layer',
  'слоёв': 'layers',
  'Все': 'All',
  'Да': 'Yes',
  'Нет': 'No',
  'Заполнено': 'Has value',
  'Пусто': 'Empty',
  'Нет значений': 'No values',

  // --- Презентации ---
  'Презентация': 'Presentation',
  'Предпросмотр': 'Preview',
  'Слайд': 'Slide',
  'Слайды': 'Slides',
  'Создайте первый слайд': 'Create your first slide',
  'Создать слайд': 'Create slide',
  'Текущий вид карты станет его камерой': 'The current map view will become its camera',
  'Выберите слайд, чтобы настроить его': 'Select a slide to edit it',
  'Дублировать': 'Duplicate',
  'Переименовать': 'Rename',
  'Камера': 'Camera',
  'Записать текущий вид': 'Save current view',
  'Записать': 'Save',
  'Вид изменён': 'View changed',
  'Перелететь к виду': 'Fly to view',
  'Переход': 'Transition',
  'Переход от предыдущего слайда к этому': 'Transition from the previous slide to this one',
  'с': 's',
  'Оформление': 'Appearance',
  'Затемнение карты': 'Map dimming',
  'Появление блоков': 'Block animation',
  'Опции': 'Options',
  'Блоки': 'Blocks',
  'Добавить блок': 'Add block',
  'Удалить блок': 'Delete block',
  'Пустой блок': 'Empty block',
  'Пустой блок — заполните его в панели справа': 'Empty block — fill it in the right panel',
  'Заголовок': 'Title',
  'Текст истории...': 'Story text...',
  'Картинка': 'Image',
  'Убрать картинку': 'Remove image',
  'Позиция': 'Position',
  'Тема': 'Theme',
  'Объекты слайда': 'Slide objects',
  'Сбросить': 'Reset',
  'На слайде': 'On slide',
  'Скрыт на этом слайде': 'Hidden on this slide',
  'Подсветить на этом слайде': 'Highlight on this slide',
  'Навести камеру на объект': 'Point camera at object',
  'Перейти': 'Go to',
  'Стиль и данные объекта — в режиме «Редактор»': 'Object style and data are in Editor mode',
  'Настройки презентации': 'Presentation settings',
  'Зритель может исследовать карту': 'Viewer can explore the map',
  'Стрелки навигации': 'Navigation arrows',
  'Индикатор прогресса': 'Progress indicator',
  'Кнопка «Исследовать карту»': '“Explore map” button',
  'Настройки действуют в публичной презентации и предпросмотре': 'Settings apply to the public presentation and preview',
  'Поделиться презентацией': 'Share presentation',
  'Опубликовать презентацию': 'Publish presentation',
  'Презентация не опубликована': 'Presentation is not published',
  'Ссылка работает независимо от публичной ссылки на карту': 'The link works independently of the public map link',
  'Выйти из предпросмотра': 'Exit preview',
  'Без анимации': 'No animation',
  'Плавно': 'Fade',
  'Плавный': 'Ease',
  'Снизу': 'Bottom',
  'Снизу вверх': 'Slide up',
  'Слева': 'Left',
  'Справа': 'Right',
  'Центр': 'Center',
  'Экран': 'Fullscreen',
  'Светлая': 'Light',
  'Тёмная': 'Dark',
  'Пролёт': 'Fly',
  'Мгновенно': 'Instant',
  'Объект сейчас редактирует {name}': 'Being edited by {name}',
  // Настройки панелей на публичной карте (ViewerSettingsDialog)
  'Настройки панелей на публичной карте': 'Public map panel settings',
  'Как зрители видят панель и карточки мест': 'How viewers see the panel and place cards',
  'Карточки': 'Cards',
  'Список мест. Подходит для гайдов': 'A list of places. Great for guides',
  'Слои и фильтры': 'Layers & filters',
  'Для больших данных и аналитики': 'For big data and analytics',
  'Раскладка списка': 'List layout',
  'Крупный': 'Large',
  'Средний': 'Medium',
  'Компактный': 'Compact',
  'Без фото': 'No photo',
  'Основное поле': 'Primary field',
  'Второе поле': 'Secondary field',
  'Описание': 'Description',
  'Не показывать': 'Hide',
  'Кнопки-ссылки': 'Link buttons',
  'Показывать ссылки места кнопками в списке': 'Show place links as buttons in the list',
  'Карточка у точки': 'Card at the pin',
  'Открывать карточку рядом с пином, а не сбоку': 'Open the card next to the pin instead of the side panel',
  // Виды пинов (PIN_MODES, карточка места)
  'Фото': 'Photo',
  'Событие': 'Event',
  'Ссылка': 'Link',
  'Иконка или эмодзи в пине секции': 'Section icon or emoji in the pin',
  'Фото-пины из обложек карточек': 'Photo pins from card covers',
  'Календарик с датой на пине': 'Calendar with the date on the pin',
  'Пин со значком ссылки': 'Pin with a link icon',

  // Язык подписей публичной карты (ViewerSettingsDialog)
  'Язык подписей на карте': 'Map label language',
  'Русский': 'Russian',

  // Панель-заглушка при ошибке рендера (PanelErrorBoundary)
  'Панель не загрузилась': 'The panel failed to load',
  'Перезагрузить страницу': 'Reload the page',
  // Пикер иконок: режим раскраски символа по параметру
  'Символ по параметру': 'Symbol by property',

  // Добавлено при мердже: ключи, которых нет в main
  'Визуализации': 'Visualizations',
  'Данные': 'Data',
  'Стиль': 'Style',
  'Способ показа': 'Display method',
  'Добавить визуализацию': 'Add visualization',
  'Удалить визуализацию': 'Delete visualization',
  'Показать визуализацию': 'Show visualization',
  'Скрыть визуализацию': 'Hide visualization',
  'Нарисуйте объект на карте или добавьте визуализацию заранее.': 'Draw an object on the map or add a visualization in advance.',
  'Выше': 'Move up',
  'Ниже': 'Move down',
  'Таблица объектов': 'Feature table',
  'Список': 'List',
  'Вид точек на карте': 'Point appearance on the map',
  'Пины': 'Pins',
  'Как зрители видят панель, список и точки на карте': 'How viewers see the panel, list, and points on the map',
  'На карте пока нет секций с местами': 'The map has no place sections yet',
  'Применяется ко всем секциям мест; точечные настройки мест остаются.': 'Applies to all place sections; per-place settings still override it.',
  'Название места под точкой на карте': 'Place name under the point on the map',
  'Подписи под пинами': 'Labels under pins',
  'URL сервера': 'Server URL',
  'GeoServer, ArcGIS Server и др. Можно вставить ссылку на GetCapabilities.': 'GeoServer, ArcGIS Server, etc. You can paste a GetCapabilities link.',
  'Логин (опц.)': 'Username (opt.)',
  'Пароль (опц.)': 'Password (opt.)',
  'Для приватных серверов доступ хранится зашифрованным; тайлы WMS идут через прокси.': 'For private servers, credentials are stored encrypted; WMS tiles go through a proxy.',
  'Найти слои': 'Find layers',
  'Не удалось получить список слоёв.': 'Failed to get the layer list.',
  'Не удалось импортировать слои.': 'Failed to import layers.',
  'WMS — картинка (растр), WFS — данные (вектор). Один слой часто есть в обоих.': 'WMS is an image (raster), WFS is data (vector). A layer is often available as both.',
  'Найдено:': 'Found:',
  'Поиск по названию или id': 'Search by name or id',
  'Выбрать все': 'Select all',
  'Снять все': 'Deselect all',
  'вектор': 'vector',
  'растр': 'raster',
  'Место': 'Place',
  'Маршрут': 'Route',
  'Ничего не выбрано': 'Nothing selected',
  'Выберите место в списке или на карте, чтобы изменить его свойства': 'Select a place in the list or on the map to edit its properties',
  'Места': 'Places',
  'Добавьте первое место': 'Add the first place',
  'Нажмите «Место» в тулбаре и кликните по карте': 'Click “Place” in the toolbar and click on the map',
  'Назад к списку': 'Back to list',
  'Секция': 'Section',
  'Действия с секцией': 'Section actions',
  'Удалить секцию': 'Delete section',
  'Удалить секцию «{name}» со всеми местами?': 'Delete section “{name}” with all its places?',
  'Настраивается в режиме «Редактор»': 'Configured in “Editor” mode',
  'У этих секций настроена раскраска или иконки по параметру — набор их перезапишет:': 'These sections have data-driven coloring or icons — applying the preset will overwrite them:',
  'Заменить настроенные стили?': 'Replace configured styles?',
  'Набор меняет подложку и стили секций. Отменить — Cmd+Z.': 'The preset changes the basemap and section styles. Undo with Cmd+Z.',
  'Ориентир (крупный пин)': 'Landmark (large pin)',
  'Поле': 'Field',
  'Новое поле': 'New field',
  'Например: Цена': 'e.g. Price',
  'Отображение': 'Display',
  'Скругление углов': 'Corner rounding',
  'Выкл': 'Off',
  'Свой цвет': 'Custom color',
  'Размер подписи': 'Label size',
  'Цвет подписи': 'Label color',
  'Стикеры': 'Stickers',
  'Эмодзи': 'Emoji',
  'Свои': 'Custom',
  'Своя иконка': 'Custom icon',
  'Загрузить свою иконку': 'Upload custom icon',
  'В проекте пока нет своих иконок': 'No custom icons in this project yet',
  'Не удалось загрузить список иконок': 'Could not load the icon list',
  'Не удалось загрузить иконку': 'Icon upload failed',
  'Свой эмодзи': 'Custom emoji',
  'Выбрать': 'Choose',
  'ОК': 'OK',
  'Настройки просмотра': 'Viewer settings',
  'Следуете за': 'Following',
  'Перестать следовать': 'Stop following',
  'Сейчас в проекте': 'Currently in the project',
  'Выбрать дату': 'Pick a date',
  'дд.мм.гггг': 'dd.mm.yyyy',
  'Панель': 'Panel',
  'Панель справа': 'Right panel',
  'Попап': 'Popup',
  'Попап у точки': 'Popup at the point',
  'Показать карточку': 'Show card',
  'Карта ещё не готова — попробуйте ещё раз': 'The map is not ready yet — try again',
  'Не удалось создать слайд: {reason}': 'Failed to create slide: {reason}',
  'Показывать: {name}': 'Show: {name}',
  'Раскрыть: {name}': 'Expand: {name}',
  'Цвет: {name}': 'Color: {name}',
  'Применить ко всей секции': 'Apply to the whole section',
  'Гео-сервер (WMS/WFS)': 'Geo server (WMS/WFS)',
  'GeoServer, ArcGIS Server и др. Подключитесь к серверу и импортируйте слои массово.': 'GeoServer, ArcGIS Server, etc. Connect to a server and bulk-import layers.',
  'Можно вставить ссылку на GetCapabilities — параметры нормализуются автоматически.': 'You can paste a GetCapabilities link — the parameters are normalized automatically.',
  'Список мест с фото и описанием': 'A list of places with photos and descriptions',
  'Классическая панель слоёв': 'Classic layer panel',
  'Точки': 'Points',
  'Точки · обычные': 'Points · regular',
  'Точки · иконки': 'Points · icons',
  'Точки · с превью': 'Points · with preview',
  'Точки · теплокарта': 'Points · heatmap',
  'Линии': 'Lines',
  'Полигоны': 'Polygons',
  'Полигоны · заливка': 'Polygons · fill',
  'Полигоны · контур': 'Polygons · outline',
  'Полигоны · 3D': 'Polygons · 3D',
  'Разное': 'Misc',
  'Еда и напитки': 'Food & drink',
  'Еда': 'Food',
  'Напитки': 'Drinks',
  'Животные': 'Animals',
  'Природа': 'Nature',
  'Активности': 'Activities',
  'Транспорт': 'Transport',
  'Символы': 'Symbols',
  'Вещи': 'Objects',
  'Креатив': 'Creator',
  // Объёмный вид карты: ландшафт, глобус, объёмные здания
  'Объёмный вид': '3D view',
  'Объёмный вид карты': 'Map 3D view',
  'Ландшафт': 'Terrain',
  'Глобус': 'Globe',
  'Объёмные здания': '3D buildings',
  'Преувеличение рельефа': 'Terrain exaggeration',
  'Отмывка рельефа': 'Hillshade',
  'Небо и туман': 'Sky and fog',
  'Атмосфера': 'Atmosphere',
  'Объём виден при наклоне камеры. Настройки наследуются публичной картой.':
    'The 3D view shows when the camera is tilted. Settings carry over to the public map.',
  'Глобус виден при отдалении: вблизи MapLibre сам переходит к плоской карте.':
    'The globe shows when zoomed out — MapLibre switches to a flat map up close.',
  'Переключаются кнопками на карте и наследуются публичной картой. Можно включить сразу несколько.':
    'Toggled by the buttons on the map and carried over to the public map. Several can be on at once.',
  'Объёмными становятся все здания базовой карты; высота — из OSM, цвет — из темы карты. Здания появляются с 14-го зума.':
    'Every basemap building becomes 3D: height comes from OSM, colour from the map theme. Buildings appear from zoom 14.',
  'Небо появляется в кадре при сильном наклоне камеры.':
    'The sky comes into view once the camera is tilted far enough.',

  // Режим «Навигация» (docs/wayfinding/plan.md)
  'Навигация': 'Wayfinding',
  'Страницы': 'Pages',
  'Загрузить план': 'Upload a plan',
  'Загружено {done} из {total}': 'Uploaded {done} of {total}',
  'Планов пока нет. Загрузите изображение или PDF.':
    'No plans yet. Upload an image or a PDF.',
  'Действия со страницей': 'Page actions',
  'Удалить страницу?': 'Delete this page?',
  'Вместе со страницей «{name}» удалятся все её объекты и весь её граф путей. Это действие нельзя отменить.':
    'Deleting the page “{name}” also deletes every object on it and its whole path graph. This cannot be undone.',
  'Новый слой': 'New layer',
  'Слоёв пока нет. Создайте слой для объектов, графа или указателей.':
    'No layers yet. Create one for objects, the graph or the signs.',
  'Свернуть слой': 'Collapse layer',
  'Развернуть слой': 'Expand layer',
  'Вне страниц': 'Outside pages',
  'Объектов нет': 'No objects',
  'Карта работает по базовой карте. Планы появятся, если сменить тип карты на «Изображение» в настройках.':
    'This map runs on the basemap. Switch the map type to “Image” in the settings to add plans.',
  'Граф': 'Graph',
  'Узел': 'Node',
  'Ребро': 'Edge',
  'Удалить узел': 'Delete node',
  'Ребро графа': 'Graph edge',
  'Конечная точка': 'Endpoint',
  'Удалить указатель': 'Delete sign',
  'Дублировать указатель': 'Duplicate sign',
  'Копия перетаскиванием недоступна: часть выбранных объектов не загружена целиком.':
    'Alt-drag copy is unavailable: some selected features are not fully loaded.',
  'Скопировано объектов: {n}. Cmd+V — в центр экрана, Shift+Cmd+V — на то же место выбранного плана.':
    'Copied {n} features. Cmd+V pastes at the screen center, Shift+Cmd+V at the same spot of the selected plan.',
  'Указатели ({count})': 'Signs ({count})',
  'Дублировать указатели ({count})': 'Duplicate signs ({count})',
  'Удалить указатели ({count})': 'Delete signs ({count})',
  'Не удалось вернуть узел': 'Could not restore the node',
  'Не удалось вернуть ребро': 'Could not restore the edge',
  'точка': 'point',
  'точки': 'points',
  'точек': 'points',
  'ребро': 'edge',
  'ребра': 'edges',
  'рёбер': 'edges',
  'Удалить из графа': 'Remove from the graph',
  'Не удалось поставить объект': 'Could not place the object',
  'Не удалось убрать объект': 'Could not remove the object',
  'Не удалось сохранить путь': 'Could not save the path',
  'Не удалось убрать путь': 'Could not remove the path',
  'Сервер ответил неожиданными данными': 'The server returned unexpected data',
  'Путь не может переходить с плана на план': 'A path cannot cross from one plan to another',
  'Этот путь уже есть в графе': 'This path is already in the graph',
  'Карта не готова — путь не сохранён': 'The map is not ready — the path was not saved',
  'Тип носителя': 'Sign type',
  'Не выбран': 'Not set',
  'Тип нельзя сменить: указатель уже наполнен. Очистите содержание, чтобы изменить носитель.':
    'The type is locked: this sign already has content. Clear the content to change the carrier.',
  'Номер': 'Number',
  'Ориентация, °': 'Orientation, °',
  'Содержание': 'Content',
  'Добавить пункт': 'Add an entry',
  'Пунктов пока нет.': 'No entries yet.',
  'Направление стрелки, °': 'Arrow direction, °',
  'Надпись': 'Label',
  'Удалить пункт': 'Delete entry',
  'Экспорт': 'Export',
  'Планы с расстановкой указателей и ведомость. Макеты указателей приходят из Автокрафта и в архив не входят.':
    'Plans with sign placement plus the specification. Sign artwork comes from Autocraft and is not part of the archive.',
  'Планы с расстановкой указателей': 'Plans with sign placement',
  'Ведомость': 'Specification',
  'Планы': 'Plans',
  'вектор (тяжелее)': 'vector (heavier)',
  'Маркер на плане': 'Marker on the plan',
  'номер': 'number',
  'выноска с содержанием': 'callout with content',
  'подписи объектов': 'object labels',
  // Легенда указателей у планов (docs/wayfinding/legend.md)
  'Легенда указателей': 'Sign legend',
  'по папкам типов': 'in folders by sign type',
  'Файлы планов': 'Plan files',
  'каждый план отдельно': 'one PDF per plan',
  'все планы одним PDF': 'all plans in one PDF',
  'общая по всем планам — в конце PDF': 'combined for all plans — at the end of the PDF',
  'у каждого плана': 'for each plan',
  'сбоку на листе плана': 'beside the plan on its sheet',
  'отдельным листом': 'as a separate page',
  'общая по всем планам — файлом в конце': 'combined for all plans — a file at the end',
  'Легенда на канвасе': 'Legend on the canvas',
  'Справа от каждого плана — его указатели по типам, под планами — общая легенда, в масштабе плана. На публичной карте — так же. Размер — только для канваса; в выгрузку легенда добавляется в окне экспорта.':
    'Each plan gets its signs by type on its right, and a combined legend sits below the plans, scaled with the plan. The public map shows them too. The size is for the canvas only; to add the legend to the export, use the Export dialog.',
  'Размер легенды': 'Legend size',
  'Не удалось сохранить легенду': 'Could not save the legend',
  'Собрано {done} из {total}': 'Built {done} of {total}',
  'Сборка не удалась': 'The build failed',
  'Готово': 'Done',
  'Скачать архив': 'Download the archive',
  'Собираем…': 'Building…',
  'Собрать': 'Build',
  'Не удалось собрать альбом': 'Could not build the album',
  // Причины отказа ручек выгрузки и сборки альбома — приходят с сервера по-русски
  // (apps/api/src/routes/wayfinding/export.ts, wayfinding-export.service.ts).
  'Нечего выгружать: не выбрано ни одной части': 'Nothing to export: no part is selected',
  'В выгрузке нет ни одного плана': 'The export has no plans',
  'На обычной карте планов нет: выгружаются ведомость и макеты указателей':
    'A regular map has no plans: the specification and sign layouts are exported',
  'Режим «Навигация» недоступен для этой карты': 'Wayfinding mode is not available for this map',
  'Задача не найдена': 'Export job not found',
  'Архив ещё не собран': 'The archive is not built yet',
  'Срок хранения архива истёк': 'The archive has expired',
  'Архив не найден в хранилище': 'The archive was not found in storage',
  'Сборка прервана: исполнитель не отвечает': 'The build was interrupted: the worker is not responding',
  'Шрифт карты нельзя вложить в PDF: у шрифтов подложки есть глифы, но нет файла. Загрузите TTF нужного шрифта в проект (Библиотека → Шрифты) и выберите его в настройках карты — альбом соберётся им.':
    'The map font cannot be embedded in a PDF: basemap fonts have glyphs but no font file. Upload a TTF of the font to the project (Library → Fonts) and pick it in the map settings — the album will use it.',
  'Не удалось загрузить план': 'Could not upload the plan',
  'Импорт остановлен: загружено {uploaded} из {total} страниц':
    'Import stopped: {uploaded} of {total} pages uploaded',
  'Загружено {uploaded} из {total} страниц — повторите импорт':
    '{uploaded} of {total} pages uploaded — run the import again',
  'Неподдерживаемый формат: {name}': 'Unsupported format: {name}',
  'Ширина плана, м': 'Plan width, m',
  'Индекс плана': 'Plan index',
  'Стоит в названиях указателей вместо номера плана. Пусто — номер по порядку.':
    'Used in sign names instead of the plan number. Empty — the plan’s position number.',
  'Не удалось сохранить индекс плана': 'Could not save the plan index',
  'Не удалось сохранить план': 'Could not save the plan',
  'Высота: {height} м': 'Height: {height} m',
  'Размер не задан — метры пока условные. Укажите реальную ширину плана.':
    'Size not set — metres are provisional. Enter the real plan width.',
  'Изменение ширины масштабирует страницу и все объекты на ней.':
    'Changing the width scales the page and everything on it.',
  'Типы носителей': 'Sign types',
  'Предложить набор': 'Suggest a set',
  'Новый тип': 'New type',
  'Добавить тип': 'Add a type',
  'Удалить тип': 'Delete type',
  'Скопировать на страницу': 'Copy to page',
  'Выберите страницу': 'Pick a page',
  'Копировать': 'Copy',
  'Остановить': 'Stop',
  'все': 'all',
  'выбранные': 'selected',
  'Отменить сборку': 'Cancel the build',
  'Сборка отменена': 'Build canceled',
  'Не удалось сохранить справочник типов': 'Could not save the sign type list',
  // Навигация: размеры знаков, нумерация по планам, картинка плана, объекты (13.09)
  'Размер на карте': 'Size on the map',
  'Указатели': 'Signs',
  'Объекты': 'Objects',
  'Общий для всех слоёв карты. Превью макетов растут вместе со знаком указателя.':
    'Shared by all layers of the map. Artwork previews grow with the sign marker.',
  'Не удалось сохранить размеры на карте': 'Could not save the map sizes',
  'Размер точек задаётся в настройках проекта — «Размер на карте».':
    'Point size is set in the project settings — “Size on the map”.',
  'Начинать на каждом плане сначала': 'Restart on every plan',
  'На каждом плане свой счёт с единицы. Новый указатель получает следующий номер на своём плане.':
    'Each plan counts from one. A new sign gets the next number on its plan.',
  'У каждого типа на каждом плане свой счёт с единицы.':
    'Each type counts from one on every plan.',
  'Указатели каждого плана получат номера подряд с 1 — в прежнем порядке, без пропусков и повторов. Названия указателей изменятся вместе с номерами, отменить пересчёт нельзя.':
    'Signs on each plan will be numbered from 1 in their current order, with no gaps or repeats. Sign names change with the numbers; renumbering cannot be undone.',
  'Указатели каждого типа на каждом плане получат номера подряд с 1 — в прежнем порядке, без пропусков и повторов. Названия указателей изменятся вместе с номерами, отменить пересчёт нельзя.':
    'Signs of each type on each plan will be numbered from 1 in their current order, with no gaps or repeats. Sign names change with the numbers; renumbering cannot be undone.',
  'Показать картинку плана': 'Show the plan image',
  'Скрыть картинку плана': 'Hide the plan image',
  'Два прямоугольника': 'Two rectangles',
  'Тип помещения': 'Room type',
  'Без типа': 'No type',
  // Общие компоненты редактора, видимые и в режиме «Навигация»
  'Удалить объекты ({count})?': 'Delete features ({count})?',
  'Отменить можно через Ctrl+Z, но история отмены живёт только до перезагрузки страницы.':
    'You can undo with Ctrl+Z, but the undo history only lasts until the page is reloaded.',
  'Привязки включены (вершины, рёбра, угол)': 'Snapping on (vertices, edges, angle)',
  'Привязки выключены': 'Snapping off',
  'Показать выделенное': 'Show selection',
  'Вырезать': 'Cut',
  'Вставить': 'Paste',
  'Переместить в слой…': 'Move to layer…',
  'Создать слой из выделенного': 'Create a layer from selection',
  'Экспортировать выделение': 'Export selection',
  'Горячие клавиши': 'Keyboard shortcuts',
  'Все сочетания клавиш редактора карты': 'All keyboard shortcuts of the map editor',
  'Не удалось выгрузить слой.': 'Could not export the layer.',
  'Экспортировать слой': 'Export layer',
  'Поиск по слоям': 'Search layers',
  'Закрыть поиск': 'Close search',
  'Слои не найдены': 'No layers found',
  'Таблица по группе': 'Group table',
  'Показать группу': 'Show group',
  'Скрыть группу': 'Hide group',
  'Адрес карты': 'Map address',
  'Латиница, цифры и дефис; от 2 символов, не начинается и не кончается дефисом':
    'Latin letters, digits and hyphens; at least 2 characters, no leading or trailing hyphen',
  'Последний сегмент публичной ссылки. Прежний адрес продолжит открывать эту карту — старые ссылки не сломаются':
    'The last segment of the public link. The previous address keeps opening this map — old links will not break',
  'Пока у команды нет своего поддомена, публичная ссылка остаётся служебной и от этого адреса не зависит. Адрес сохранится и заработает, когда поддомен включат':
    'Until the team has its own subdomain, the public link stays a service link and does not depend on this address. The address will be saved and start working once the subdomain is enabled',
  'Не удалось изменить доступ': 'Could not change access',
  'Доступна всему воркспейсу': 'Available to the whole workspace',
  'Участники воркспейса видят карту по своей роли': 'Workspace members see the map according to their role',
  'Карту видят только автор и те, кого позвали в неё отдельно':
    'Only the author and people invited to the map separately can see it',
  'Менять видимость может автор карты или владелец воркспейса':
    'Visibility can be changed by the map author or the workspace owner',
  'Вставить в конец текста': 'Insert at the end of the text',
  'В тексте остались ссылки на файлы, которых нет в списке:':
    'The text still links to files that are not in the list:',
  'Вид пина': 'Pin style',
  'Индивидуальный стиль недоступен для слоёв из внешнего источника тайлов.':
    'Per-feature style is not available for layers from an external tile source.',
  'Стиль объекта': 'Feature style',
  'Как у слоя': 'Same as layer',
  'Цвет объекта': 'Feature color',
  'Цвет слоя': 'Layer color',
  'как у слоя': 'same as layer',
  'Непрозрачность': 'Opacity',
  'Фон': 'Background',
  'задано выражением': 'set by an expression',
  'Выделение работает внутри одного слоя — набор заменён':
    'Selection works within a single layer — the selection was replaced',
  'Выделены первые {limit} объектов из {total} — потолок выделения':
    'Selected the first {limit} of {total} features — selection limit reached',
  'Слой заблокирован: удаление недоступно.': 'The layer is locked: deleting is unavailable.',
  'Не удалось удалить объект': 'Could not delete the feature',
  'Сначала создайте тип указателя — справа, в блоке «Типы указателей»':
    'Create a sign type first — on the right, in the “Sign types” block',
  'Не удалось выгрузить выделение.': 'Could not export the selection.',
  'Рисовать можно только в векторный слой — создан новый слой':
    'You can only draw into a vector layer — a new layer was created',
  'В этот слой рисовать нельзя — объект добавлен в слой «{name}»':
    'You can’t draw into this layer — the feature was added to the “{name}” layer',
  'Не удалось вставить объекты.': 'Could not paste the features.',
  'Слой заблокирован: дублирование недоступно.': 'The layer is locked: duplicating is unavailable.',
  'Дублирование пока поддержано только для векторных объектов.':
    'Duplicating is only supported for vector features so far.',
  'Объекты не найдены.': 'Features not found.',
  'Копирование пока поддержано только для векторных объектов.':
    'Copying is only supported for vector features so far.',
  'Вырезание пока поддержано только для векторных объектов.':
    'Cutting is only supported for vector features so far.',
  'Слой заблокирован: вставка недоступна.': 'The layer is locked: pasting is unavailable.',
  'Вставлено {n} объектов из внешнего источника': 'Pasted {n} features from an external source',
  'Слой заблокирован: перенос объектов недоступен.': 'The layer is locked: moving features is unavailable.',
  'Создать слой из выделенного можно только для векторных объектов.':
    'A layer can only be created from selected vector features.',
  'Не удалось создать слой из выделенного.': 'Could not create a layer from the selection.',
  'Объекты {number}': 'Objects {number}',
  'Указатели {number}': 'Signs {number}',
  'Поле добавлено не везде: {names}': 'The field was not added everywhere: {names}',
  'Поле добавлено в слои: {n}': 'Field added to layers: {n}',
  'Поле снято со слоёв: {n}': 'Field removed from layers: {n}',
  'Одинаковое имя при разном типе — это разные поля, они показаны отдельными колонками':
    'Same name with a different type — these are different fields, shown as separate columns',
  'поля с разным типом: {names}': 'fields with different types: {names}',
  'часть строк не загружена (тайловые слои)': 'some rows are not loaded (tiled layers)',
  'Добавьте первое поле — оно появится во всех слоях группы.':
    'Add the first field — it will appear in every layer of the group.',
  'Выбрать объект': 'Select an object',
  'Значение из таблицы объектов: {column}': 'Value from the objects table: {column}',
  'Поиск объекта': 'Search objects',
  'Объект станет конечной точкой указателя и наполнит все связанные поля; это — из поля «{column}».':
    'The object becomes the sign’s endpoint and fills all linked fields; this one is from the “{column}” field.',
  'Строка наполнит все связанные поля макета; это — из поля «{column}».':
    'The row fills all linked layout fields; this one is from the “{column}” field.',
  'На этом плане нет объектов с заполненным полем «{column}»':
    'This plan has no objects with the “{column}” field filled in',
  'поле «{column}» пустое': 'the “{column}” field is empty',
  'Отвязать от объекта': 'Unlink from the object',
  'Объекта больше нет на этом плане — в макет уходит последний известный текст.':
    'The object is no longer on this plan — the layout gets the last known text.',
  'Значения «{value}» нет среди вариантов поля — Автокрафт его не нарисует.':
    '“{value}” is not among the field’s options — Autocraft will not render it.',
  // Режим «Навигация»: Автокрафт, выгрузка, чужой макет, планы, размер знака
  'и ещё {count}': 'and {count} more',
  'Не удалось сохранить ссылку.': 'Could not save the link.',
  'Подключение работает, генераторов: {count}': 'Connection works, generators: {count}',
  'Не удалось подключиться': 'Could not connect',
  'Ссылка сохранена, генераторов: {count}': 'Link saved, generators: {count}',
  'Добавлено типов указателей под новые генераторы: {count}':
    'Sign types added for new generators: {count}',
  'Типы под новые генераторы не заведены. {reason}': 'Sign types for new generators were not added. {reason}',
  'Не удалось перечитать настройки карты.': 'Could not reload the map settings.',
  'Типы под остальные генераторы не заведены — нажмите «Проверить» в блоке «Автокрафт».':
    'Sign types for the other generators were not added — press “Check” in the Autocraft block.',
  'Вставьте ссылку на проект Автокрафта — его генераторы станут доступны всем указателям карты.':
    'Paste a link to an Autocraft project — its generators become available to every sign on the map.',
  'Загружаем генераторы…': 'Loading generators…',
  'Генераторов: {count}. Генератор макета выбирается у каждого указателя.':
    'Generators: {count}. The layout generator is chosen for each sign.',
  'Проверить': 'Check',
  'У слоя карты уже есть ссылка на Автокрафт — её можно взять.':
    'A map layer already has an Autocraft link — you can use it.',
  'У слоёв карты разные ссылки на Автокрафт. Указатели работают с одной — выберите её.':
    'Map layers have different Autocraft links. Signs work with one — pick it.',
  'Взять ссылку: {names}, проект {project}': 'Use the link: {names}, project {project}',
  'Взять': 'Use',
  'Слои {names} ссылаются на другие проекты Автокрафта ({projects}): указатели их генераторы не видят, макеты этих слоёв правятся в «Редакторе».':
    'Layers {names} link to other Autocraft projects ({projects}): signs cannot see their generators, and those layers’ layouts are edited in the “Editor”.',
  'Слои {names} ссылаются на другой проект Автокрафта ({projects}): указатели его генераторы не видят, макеты этих слоёв правятся в «Редакторе».':
    'Layers {names} link to another Autocraft project ({projects}): signs cannot see its generators, and those layers’ layouts are edited in the “Editor”.',
  'Точки слоёв Автокрафта — не указатели: у них нет номеров, в ведомость и выгрузку макетов они не попадут.':
    'Points of Autocraft layers are not signs: they have no numbers and will not appear in the specification or the layout export.',
  'Сделать слоем указателей: {name}': 'Make a sign layer: {name}',
  'Сделать указателями': 'Make signs',
  'Ключ из ссылки не показывается — он хранится зашифрованным. Чтобы сменить проект или ключ, вставьте ссылку из Автокрафта целиком.':
    'The key from the link is not shown — it is stored encrypted. To change the project or the key, paste the full link from Autocraft.',
  'Обновить все макеты': 'Refresh all layouts',
  'Указателей с данными другого генератора: {count}. Прогон заменит эти данные значениями по умолчанию — отменить это нельзя.':
    'Signs with data from another generator: {count}. The run replaces that data with defaults — this cannot be undone.',
  'Заменить и обновить': 'Replace and refresh',
  'Считаем указатели…': 'Counting signs…',
  'Указателей с генератором Автокрафта на карте нет.':
    'There are no signs with an Autocraft generator on the map.',
  'Обновлено макетов: {count}, не собрано: {failed}': 'Layouts refreshed: {count}, failed to build: {failed}',
  'Обновлено макетов: {count}': 'Layouts refreshed: {count}',
  'Автокрафт перестал отвечать — прогон остановлен. Обновлено макетов: {count}, не обновлено: {rest}.':
    'Autocraft stopped responding — the run was stopped. Layouts refreshed: {count}, not refreshed: {rest}.',
  'Остановлено. Обновлено макетов: {count}, не обновлено: {rest}.':
    'Stopped. Layouts refreshed: {count}, not refreshed: {rest}.',
  'Обновить оставшиеся ({count})': 'Refresh the rest ({count})',
  '— {names} и ещё {count}': '— {names} and {count} more',
  '…и ещё причин: {count}': '…and {count} more reasons',
  'Указатели заново отправят свои данные в Автокрафт. Нужно, когда в Автокрафте поменяли дизайн генератора.':
    'Signs will send their data to Autocraft again. Needed when the generator design was changed in Autocraft.',
  'Не удалось скачать архив': 'Could not download the archive',
  'Планы с расстановкой указателей, ведомость, макеты указателей и таблицы — что отмечено.':
    'Plans with sign placement, the specification, sign layouts and tables — whatever is checked.',
  'Ведомость, макеты указателей и таблицы — что отмечено. Указатели стоят на обычной карте, поэтому планов с расстановкой в выгрузке нет.':
    'The specification, sign layouts and tables — whatever is checked. Signs are placed on a regular map, so the export has no plans with sign placement.',
  'Таблицы (Excel)': 'Tables (Excel)',
  'лист на группу': 'sheet per group',
  'лист на слой': 'sheet per layer',
  'Таблиц нет: нет слоёв с данными объектов.': 'No tables: there are no layers with object data.',
  'Листов: {count}. Все объекты слоёв, без фильтров таблицы; ляжет в архив файлом {file}.':
    'Sheets: {count}. All objects of the layers, without table filters; goes into the archive as {file}.',
  'В колонку PDF несобранные макеты соберутся по одному — это займёт время.':
    'Layouts that are not built yet will be built one by one for the PDF column — this takes time.',
  'Таблицы': 'Tables',
  'Таблицы не собрались': 'Tables were not built',
  'Таблицы готовы': 'Tables are ready',
  'Таблицы готовы. Не собрались макеты: {count} — в файле их ячейки пустые':
    'Tables are ready. Layouts not built: {count} — their cells in the file are empty',
  'Скачать таблицы': 'Download tables',
  'Архив большой — таблицы скачаны рядом отдельным файлом {file}':
    'The archive is large — the tables were downloaded next to it as {file}',
  'Не удалось выгрузить таблицы': 'Could not export the tables',
  'Не загрузилась схема генератора Автокрафта — повторите выгрузку':
    'The Autocraft generator schema did not load — try the export again',
  'Объектов на планах нет — листы уйдут пустыми. В выгрузку идут объекты видимых слоёв, привязанные к плану.':
    'There are no objects on the plans — the sheets will be empty. The export includes objects of visible layers that are attached to a plan.',
  'Объектов на планах: {count}': 'Objects on plans: {count}',
  'Указателей нет — в выгрузку идут указатели видимых слоёв.':
    'There are no signs — the export includes signs of visible layers.',
  'Указателей: {count}': 'Signs: {count}',
  'Макеты указателей': 'Sign layouts',
  'Макетов на планах нет: у типов нет генератора Автокрафта, и свои PDF не загружены.':
    'There are no layouts on the plans: the types have no Autocraft generator and no custom PDFs are uploaded.',
  'Макетов нет: у типов нет генератора Автокрафта, и свои PDF не загружены.':
    'There are no layouts: the types have no Autocraft generator and no custom PDFs are uploaded.',
  'Макетов: {count} — из Автокрафта {autocraft}, своих {own}.':
    'Layouts: {count} — from Autocraft {autocraft}, custom {own}.',
  'Несобранные PDF Автокрафта соберутся по данным указателей — это займёт время.':
    'Autocraft PDFs that are not built yet will be built from the signs’ data — this takes time.',
  'Без макета: {count} — их список ляжет в архив, в layouts/отчёт.txt.':
    'Without a layout: {count} — the list goes into the archive, in layouts/отчёт.txt.',
  'Какие планы': 'Which plans',
  'Макеты с каких планов': 'Layouts from which plans',
  'Формат планов': 'Plan format',
  'название': 'name',
  'Точки слоёв Автокрафта {names} — не указатели: на планах они будут маркерами, но в ведомость и макеты не попадут. Сделать их указателями можно в настройках проекта или в свойствах слоя.':
    'Points of Autocraft layers {names} are not signs: they appear as markers on the plans but not in the specification or layouts. You can make them signs in the project settings or in the layer properties.',
  'Точки слоёв Автокрафта {names} — не указатели: в ведомость и макеты не попадут. Сделать их указателями можно в настройках проекта или в свойствах слоя.':
    'Points of Autocraft layers {names} are not signs: they will not appear in the specification or layouts. You can make them signs in the project settings or in the layer properties.',
  'Скачиваем…': 'Downloading…',
  'Макет заполнен генератором «{name}»': 'The layout was filled by the “{name}” generator',
  'Макет заполнен другим генератором': 'The layout was filled by another generator',
  'Заполнено полей: {count}. У типа «{type}» другой генератор — его форма заменила бы эти данные значениями по умолчанию.':
    'Fields filled: {count}. The “{type}” type has another generator — its form would replace this data with defaults.',
  'Заполнено полей: {count}. У типа указателя другой генератор — его форма заменила бы эти данные значениями по умолчанию.':
    'Fields filled: {count}. The sign type has another generator — its form would replace this data with defaults.',
  'Этого генератора нет в проекте Автокрафта, на который ссылается карта: данные собраны в другом проекте.':
    'This generator is not in the Autocraft project the map links to: the data was built in another project.',
  'Сменить тип на «{name}»': 'Change the type to “{name}”',
  'Создать тип «{name}»': 'Create the “{name}” type',
  'Заменить умолчаниями': 'Replace with defaults',
  'План {name}': 'Plan {name}',
  'Действия с планом': 'Plan actions',
  'Заменить исходник': 'Replace source',
  'Какую страницу взять?': 'Which page to use?',
  'В «{file}» страниц: {count}. Выбранная станет подложкой плана «{plan}» — объекты и указатели останутся на местах.':
    '“{file}” has {count} pages. The chosen one becomes the image of plan “{plan}”; its objects and signs stay in place.',
  'Превью не получилось, но страницу можно взять': 'Preview failed, but the page can still be used',
  'Не удалось заменить исходник': 'Could not replace the source',
  'Замена исходника остановлена': 'Source replacement stopped',
  'Растр не совпадает со страницей исходного PDF': 'The image does not match the page of the source PDF',
  'Исходник и страница PDF передаются вместе': 'The source PDF and its page must be sent together',
  'Некорректная ссылка на исходник': 'Invalid source link',
  'Не удалось прочитать PDF': 'Could not read the PDF',
  'Не удалось нарисовать страницу PDF': 'Could not render the PDF page',
  'Удалить план?': 'Delete this plan?',
  'Вместе с планом «{name}» удалятся его объекты ({features}) и рёбра графа ({edges}). Это действие нельзя отменить.':
    'Deleting the plan “{name}” also deletes its objects ({features}) and graph edges ({edges}). This cannot be undone.',
  'Как в проекте': 'Same as project',
  'Свой размер слоя. Общий размер карты — в настройках проекта.':
    'This layer has its own size. The shared map size is in the project settings.',
  'Как в проекте — «Размер на карте». Измените, чтобы задать слою свой.':
    'Same as the project — “Size on the map”. Change it to give this layer its own.',
  // Якорь превью макетов: общее правило задаёт тип, слой и указатель переопределяют
  'Как у типа': 'Same as type',
  'Как у типа слоя. Выберите, чтобы задать свой якорь всем указателям слоя.':
    'Same as the layer’s type. Pick one to give every sign in this layer its own anchor.',
  'Как у типа каждого указателя. Выберите, чтобы задать свой якорь всем указателям слоя.':
    'Same as each sign’s type. Pick one to give every sign in this layer its own anchor.',
  'Свой якорь слоя. Якорь типа — в настройках проекта, у указателя можно задать свой.':
    'This layer has its own anchor. The type anchor is in the project settings; a sign can set its own.',
  'Как у слоя. Выберите, чтобы задать указателю свой якорь.':
    'Same as the layer. Pick one to give this sign its own anchor.',
  'Как у типа. Выберите, чтобы задать указателю свой якорь.':
    'Same as the type. Pick one to give this sign its own anchor.',
  'Свой якорь указателя. Остальные указатели слоя следуют слою и типу.':
    'This sign has its own anchor. The other signs in the layer follow the layer and the type.',
  // Якорь подписи указателя: та же цепочка тип → слой → указатель
  'Якорь подписи': 'Label anchor',
  'Как у типа слоя. Выберите, чтобы задать свой якорь подписи всем указателям слоя.':
    'Same as the layer’s type. Pick one to give every sign label in this layer its own anchor.',
  'Как у типа каждого указателя. Выберите, чтобы задать свой якорь подписи всем указателям слоя.':
    'Same as each sign’s type. Pick one to give every sign label in this layer its own anchor.',
  'Свой якорь подписи слоя. Якорь типа — в настройках проекта, у указателя можно задать свой.':
    'This layer has its own label anchor. The type anchor is in the project settings; a sign can set its own.',
  'Как у слоя. Выберите, чтобы задать подписи указателя свой якорь.':
    'Same as the layer. Pick one to give this sign’s label its own anchor.',
  'Как у типа. Выберите, чтобы задать подписи указателя свой якорь.':
    'Same as the type. Pick one to give this sign’s label its own anchor.',
  'Свой якорь подписи указателя. Остальные указатели слоя следуют слою и типу.':
    'This sign’s label has its own anchor. The other signs in the layer follow the layer and the type.',
  // Режим «Навигация»: «Сделать указателями», раздел размеров, конечная точка, макет PDF, тип слоя
  'Не удалось создать типы указателей — обновите страницу и повторите.':
    'Could not create the sign types — reload the page and try again.',
  'Не удалось сохранить типы указателей.': 'Could not save the sign types.',
  'Слой «{name}» — теперь слой указателей. Указателей: {count}':
    '“{name}” is now a sign layer. Signs: {count}',
  'Не удалось сделать слой слоем указателей.': 'Could not turn the layer into a sign layer.',
  'Сделать «{name}» слоем указателей': 'Make “{name}” a sign layer',
  'Точки слоя станут указателями: получат тип и номер, попадут в ведомость и в выгрузку макетов. Данные макетов Автокрафта сохранятся. Отменить это нельзя.':
    'The layer’s points become signs: they get a type and a number and appear in the specification and the layout export. Autocraft layout data is kept. This cannot be undone.',
  'Считаем точки…': 'Counting points…',
  'Не удалось загрузить объекты слоя.': 'Could not load the layer’s objects.',
  'Точек: {count}': 'Points: {count}',
  'Названия из «Редактора» сохранятся у всех точек.': 'Names from the “Editor” are kept for all points.',
  'Названия из «Редактора» сохранятся у точек: {count}. Остальные назовутся по шаблону проекта.':
    'Names from the “Editor” are kept for {count} points. The rest are named by the project template.',
  'Линии и полигоны ({count}) останутся в слое как есть — указатели только точки.':
    'Lines and polygons ({count}) stay in the layer as they are — only points become signs.',
  'У карты нет ссылки на Автокрафт, а у ссылки слоя нет ключа. Вставьте ссылку на проект Автокрафта в настройках проекта.':
    'The map has no Autocraft link, and the layer’s link has no key. Paste an Autocraft project link in the project settings.',
  'У карты ещё нет ссылки на Автокрафт — возьмём ссылку этого слоя.':
    'The map has no Autocraft link yet — we will use this layer’s link.',
  'Слой ссылается на другой проект Автокрафта, чем карта: генераторы его точек указателям недоступны. Данные макетов сохранятся, но собрать макет заново можно будет, только заменив их значениями по умолчанию.':
    'The layer links to a different Autocraft project than the map: its points’ generators are unavailable to signs. Layout data is kept, but a layout can only be rebuilt by replacing that data with defaults.',
  'Макеты точек': 'Point layouts',
  'Тип «{name}» — точек: {count}': 'Type “{name}” — points: {count}',
  'Новый тип «{name}» — точек: {count}': 'New type “{name}” — points: {count}',
  'Генератор не найден в проекте ссылки — точек: {count}, данные сохранятся':
    'Generator not found in the linked project — points: {count}, data is kept',
  'У типа свой якорь превью — превью встанут по нему, а не как в слое.':
    'The type has its own preview anchor — previews follow it rather than the layer’s.',
  'Без макета — точек: {count}, получат тип слоя': 'No layout — points: {count}, they get the layer’s type',
  'Новые типы возьмут якорь превью из слоя, в том числе по страницам.':
    'New types take the preview anchor from the layer, including per-page anchors.',
  'Новые типы возьмут якорь превью из слоя.': 'New types take the preview anchor from the layer.',
  'Тип слоя': 'Layer type',
  '{name} (новый)': '{name} (new)',
  'Точки с другим генератором получат свой тип — по генератору их макета.':
    'Points with another generator get their own type — based on their layout’s generator.',
  'Сделать слоем указателей': 'Make a sign layer',
  'Слой Автокрафта из «Редактора»: его точки — не указатели. У них нет номеров, в ведомость и выгрузку макетов они не попадают, а макеты правятся только в «Редакторе».':
    'An Autocraft layer from the “Editor”: its points are not signs. They have no numbers, do not appear in the specification or the layout export, and their layouts are edited only in the “Editor”.',
  'Точки этого слоя — не указатели: у них нет номеров, и в ведомость они не попадают.':
    'This layer’s points are not signs: they have no numbers and do not appear in the specification.',
  'Общий для слоёв карты; у слоя можно задать свой в его стиле. Превью макетов растут вместе со знаком указателя.':
    'Shared by the map’s layers; a layer can set its own in its style. Layout previews grow with the sign marker.',
  'Подписи указателей': 'Sign labels',
  'Подписи объектов': 'Object labels',
  'Подпись объекта': 'Object label',
  'Не удалось сохранить подпись объектов': 'Could not save the object label',
  'Поля объекта — в фигурных скобках, остальное остаётся как написано: «{Номер} {Название}».':
    'Object fields go in curly braces; everything else stays as typed — for example, the number before the name.',
  'Объект не найден': 'Object not found',
  'Не выбрана': 'Not selected',
  'Название или номер': 'Name or number',
  'На этом плане нет объектов. Поставьте их инструментом «Конечная точка».':
    'There are no objects on this plan. Place them with the “Endpoint” tool.',
  'Снять конечную точку': 'Clear the endpoint',
  'Объекта нет на плане этого указателя — его удалили или указатель перенесли. Поля макета держат последний известный текст.':
    'The object is not on this sign’s plan — it was deleted or the sign was moved. The layout fields keep the last known text.',
  'Типов указателей пока нет. Создайте их в настройках проекта — они справа, когда ничего не выбрано.':
    'There are no sign types yet. Create them in the project settings — they are on the right when nothing is selected.',
  'Макет загружается в PDF': 'The layout is uploaded as a PDF',
  'PDF больше {size} МБ — уменьшите файл': 'The PDF is larger than {size} MB — make the file smaller',
  'Не удалось загрузить макет': 'Could not upload the layout',
  'Макет': 'Layout',
  'Готовим превью и загружаем макет…': 'Preparing the preview and uploading the layout…',
  'Показаны первые {shown} страниц из {total}.': 'Showing the first {shown} of {total} pages.',
  'Убрать': 'Remove',
  'У типа нет генератора Автокрафта — загрузите готовый макет в PDF. Он попадёт в выгрузку макетов.':
    'The type has no Autocraft generator — upload a ready-made layout as a PDF. It goes into the layout export.',
  'Загрузить PDF': 'Upload PDF',
  // Режим «Навигация»: нумерация, свойства указателя, типы, инструменты, правая/левая панель, хуки
  'Нумерация': 'Numbering',
  'Сквозная': 'Continuous',
  'По типам': 'By type',
  'Один счёт на все указатели карты. Новый указатель получает следующий номер.':
    'One count for all signs on the map. A new sign gets the next number.',
  'У каждого типа свой счёт с единицы. Новый указатель получает следующий номер в своём типе.':
    'Each type counts from one. A new sign gets the next number within its type.',
  'Указателей пока нет': 'No signs yet',
  'Номера идут подряд': 'Numbers are consecutive',
  'Есть пропуски или повторы': 'There are gaps or repeats',
  'Пересчитать': 'Renumber',
  'Название указателя': 'Sign name',
  'Пример:': 'Example:',
  'Переменные — в фигурных скобках, остальное остаётся как написано. {signNumber:3} дополнит номер нулями до трёх знаков.':
    'Variables go in curly braces, the rest stays as written. {signNumber:3} pads the number with zeros to three digits.',
  'Пересчитать номера?': 'Renumber the signs?',
  'Все указатели карты получат номера подряд с 1 — в прежнем порядке, без пропусков и повторов. Названия указателей изменятся вместе с номерами, отменить пересчёт нельзя.':
    'All signs on the map will be numbered from 1 in their current order, with no gaps or repeats. Sign names change with the numbers; renumbering cannot be undone.',
  'Указатели каждого типа получат номера подряд с 1 — в прежнем порядке, без пропусков и повторов. Названия указателей изменятся вместе с номерами, отменить пересчёт нельзя.':
    'Signs of each type will be numbered from 1 in their current order, with no gaps or repeats. Sign names change with the numbers; renumbering cannot be undone.',
  'Превью макетов': 'Layout previews',
  'Тип': 'Type',
  'Как у слоя: {name}': 'Same as layer: {name}',
  'Выберите тип': 'Select a type',
  'Тип не назначен: на карте указатель серый, в ведомости у него пустые тип и код.':
    'No type assigned: the sign is gray on the map, and its type and code are empty in the specification.',
  'Полный номер': 'Full number',
  'Такое название уже есть на карте — поправьте номер или нажмите «Пересчитать» в настройках проекта.':
    'This name already exists on the map — fix the number or click “Renumber” in the project settings.',
  'Макет Автокрафта: вставьте ссылку на проект Автокрафта в настройках проекта — они справа, когда ничего не выбрано.':
    'Autocraft layout: paste an Autocraft project link in the project settings — they are on the right when nothing is selected.',
  'В таблице объектов пока нет полей. Заведите слой объектов и его поля — они станут столбцами общей таблицы и появятся здесь.':
    'The objects table has no fields yet. Create an objects layer and its fields — they become columns of the shared table and appear here.',
  'Загружаем поля генератора…': 'Loading generator fields…',
  'Не удалось получить поля генератора': 'Could not get the generator fields',
  'У генератора нет полей, которые можно наполнять': 'The generator has no fields that can be filled',
  'Не связано': 'Not linked',
  '{name} — поля нет в объектах': '{name} — the field is not in the objects',
  'Типы указателей': 'Sign types',
  'Каждый указатель на карте относится к одному типу. Создайте первый — название, код, цвет и иконку можно поменять в любой момент.':
    'Every sign on the map belongs to one type. Create the first one — its name, code, color and icon can be changed at any time.',
  'Указателей этого типа': 'Signs of this type',
  'Генератор не найден': 'Generator not found',
  'Тип указателя': 'Sign type',
  'Генератор макета': 'Layout generator',
  'Автокрафт не подключён': 'Autocraft is not connected',
  'Без генератора': 'No generator',
  'Настроить связи': 'Set up links',
  'Связи с объектами': 'Links to objects',
  'Поле макета наполняется из общей таблицы объектов: выберите, из какого столбца брать значение.':
    'A layout field is filled from the shared objects table: choose which column to take the value from.',
  'Настенный односторонний': 'Wall-mounted, single-sided',
  'Код': 'Code',
  'Сторон': 'Sides',
  'Цвет типа': 'Type color',
  'HEX цвета типа': 'Type color HEX',
  'По числу сторон': 'By number of sides',
  'По сторонам': 'By sides',
  'Материал': 'Material',
  'Электроподключение': 'Power connection',
  'Тип стоит у указателей: {count}. Чтобы удалить его, смените им тип.':
    'The type is used by signs: {count}. To delete it, change their type.',
  'Тип выбран у слоёв: {count}. Чтобы удалить его, смените тип слоям.':
    'The type is set on layers: {count}. To delete it, change the layers’ type.',
  'Указатель': 'Sign',
  'Изменить высоту списка планов': 'Resize the plans list',
  'Название объекта': 'Object name',
  'План': 'Plan',
  'Проект': 'Project',
  'Скопировать на план': 'Copy to plan',
  'Выберите план': 'Select a plan',
  'Индекс проекта': 'Project index',
  'Входит в названия указателей, если в шаблоне есть «Индекс проекта».':
    'Included in sign names when the template has “Project index”.',
  'Указатели расставляются по загруженным планам.': 'Signs are placed on the uploaded plans.',
  'Указатели расставляются поверх базовой карты. Для работы по планам выберите «Изображение».':
    'Signs are placed on top of the basemap. To work with plans, choose “Image”.',
  'Номера пересчитаны: {count}': 'Signs renumbered: {count}',
  'Номера уже идут подряд': 'Numbers are already consecutive',
  'Не удалось пересчитать номера': 'Could not renumber the signs',
  'Имя плана': 'Plan name',
  'Изменение ширины масштабирует план и все объекты на нём.':
    'Changing the width scales the plan and everything on it.',
  'Импорт остановлен: загружено {uploaded} из {total} планов':
    'Import stopped: {uploaded} of {total} plans uploaded',
  'Загружено {uploaded} из {total} планов — повторите импорт':
    '{uploaded} of {total} plans uploaded — run the import again',
  'Не удалось сохранить типы указателей': 'Could not save the sign types',
  'Тип {number}': 'Type {number}',
  'Не удалось сохранить настройки нумерации': 'Could not save the numbering settings',
  'Выберите план в списке слева — вставляем на него':
    'Select a plan in the list on the left — we paste onto it',
  'Не удалось вставить объекты': 'Could not paste the objects',
  // Навигация и общие панели: подписи-константы, доходящие до экрана через et(label), и тосты
  'Входы и выходы': 'Entrances and exits',
  'Пути': 'Paths',
  'Между этажами': 'Between floors',
  'Помещения': 'Rooms',
  'Услуги': 'Services',
  'Другие': 'Other',
  'Вход / выход': 'Entrance / exit',
  'Эвакуационный выход': 'Emergency exit',
  'Коридор': 'Corridor',
  'Холл': 'Lobby',
  'Лестница': 'Stairs',
  'Лифт': 'Elevator',
  'Эскалатор': 'Escalator',
  'Пандус': 'Ramp',
  'Общего пользования': 'Public area',
  'Зал': 'Hall',
  'Кабинет / офис': 'Office',
  'Служебное': 'Staff only',
  'Техническое': 'Technical',
  'Туалет': 'Restroom',
  'Гардероб': 'Cloakroom',
  'Информация / ресепшн': 'Information / reception',
  'Касса': 'Ticket office',
  'Кафе / столовая': 'Cafe / canteen',
  'Магазин': 'Shop',
  'Медпункт': 'First aid',
  'Комната матери и ребёнка': 'Parent and baby room',
  'Общие слои': 'Common layers',
  'Треугольник': 'Triangle',
  'Размер знака': 'Sign size',
  'Размер точки': 'Point size',
  'Не удалось удалить узел': 'Could not delete the node',
  'Не удалось удалить ребро': 'Could not delete the edge',
  'Слой объектов скрыт — покажите его, чтобы ставить узлы':
    'The objects layer is hidden — show it to place nodes',
  'Слой объектов заблокирован — разблокируйте его, чтобы ставить узлы':
    'The objects layer is locked — unlock it to place nodes',
  'Укажите полную ссылку на проект Автокрафта.': 'Enter the full link to the Autocraft project.',
  'В ссылке Автокрафта отсутствует параметр hash.': 'The Autocraft link has no hash parameter.',
  'Ссылка Автокрафта должна начинаться с http:// или https://.':
    'The Autocraft link must start with http:// or https://.',
  'Ссылка должна вести на /api/project/{project}/generators.':
    'The link must point to /api/project/{project}/generators.',
  'Сервер ответил неожиданными данными — прогон остановлен':
    'The server returned unexpected data — the run was stopped',
  'Не удалось обновить макеты': 'Could not refresh the layouts',
  'Не удалось закодировать страницу PDF в изображение': 'Could not encode the PDF page as an image',
  'Браузер не дал 2D-контекст для растеризации PDF':
    'The browser did not provide a 2D context to rasterize the PDF',
  'Браузер не дал 2D-контекст для превью PDF': 'The browser did not provide a 2D context for the PDF preview',
  'По умолчанию (системный)': 'Default (system)',
  'Минималистичная': 'Minimal',
  'Выделение': 'Selection',
  'Выделить все объекты активного слоя': 'Select all features of the active layer',
  'Снять выделение и выйти из режима рисования': 'Clear the selection and exit drawing mode',
  'Подогнать камеру под выделение': 'Fit the camera to the selection',
  'Сдвинуть выделение на 1 px (с Shift — на 10 px)': 'Nudge the selection by 1 px (10 px with Shift)',
  'Правка': 'Edit',
  'Отменить': 'Undo',
  'Повторить': 'Redo',
  'Удалить выбранное': 'Delete selected',
  'Инструменты рисования': 'Drawing tools',
  'Прочее': 'Other',
  'Показать это окно': 'Show this window',
  'Строка': 'Text',
  'Число': 'Number',
  'Дата': 'Date',
  'Угол': 'Angle',
  'Да/Нет': 'Yes/No',
  'Массив': 'Array',
  'Селект': 'Select',
  'Линейно': 'Linear',
  'Экспон.': 'Exp.',
  'Ступени': 'Steps',
  'Цвет без значения': 'Color when no value',
  'Встроенные': 'Built-in',
  'Иконки': 'Icons',
  'Смещение текста': 'Text offset',
  'Поворот оттенка (°)': 'Hue rotation (°)',
  'км': 'km',
  'Не удалось удалить выбранные объекты.': 'Could not delete the selected features.',
  '3D-объекты можно переносить только в другие 3D-слои.': '3D objects can only be moved to other 3D layers.',
  'В 3D-слой можно переносить только объекты из другого 3D-слоя.':
    'Only objects from another 3D layer can be moved into a 3D layer.',
  'Изображения можно переносить только в другие растровые слои.':
    'Images can only be moved to other raster layers.',
  'В растровый слой можно переносить только объекты из другого растрового слоя.':
    'Only objects from another raster layer can be moved into a raster layer.',
  'Не удалось перенести объекты.': 'Could not move the features.',
  'Не удалось обновить выбранные объекты.': 'Could not update the selected features.',
  'Не удалось обновить значение у объектов слоя': 'Could not update the value on the layer’s features',
  'Не удалось сдвинуть выделенные объекты.': 'Could not shift the selected features.',
  'Не удалось повернуть выделенные объекты.': 'Could not rotate the selected features.',
  'Не удалось изменить размер выделенных объектов.': 'Could not resize the selected features.',
  'Не удалось загрузить изображение': 'Could not upload the image',
  'Не удалось дублировать слой.': 'Could not duplicate the layer.',
  'Слой скопирован в выбранный проект.': 'The layer was copied to the selected project.',
  'Не удалось скопировать слой в другой проект.': 'Could not copy the layer to another project.',
  'Не удалось сохранить тип карты. Проверьте сеть и попробуйте снова.':
    'Could not save the map type. Check your connection and try again.',
  'Не удалось сохранить стиль карты. Проверьте сеть и попробуйте снова.':
    'Could not save the map style. Check your connection and try again.',
  'Не удалось сохранить изменения слоя. Проверьте сеть и попробуйте снова.':
    'Could not save the layer changes. Check your connection and try again.',
  'Не удалось сохранить изменения объекта. Проверьте сеть и попробуйте снова.':
    'Could not save the feature changes. Check your connection and try again.',
  'Выделены первые {shown} из {total} объектов': 'Selected the first {shown} of {total} features',
  // Таблица группы слоёв: причина отказа в добавлении поля
  'поле «{name}» уже есть с другим типом ({type})':
    'the “{name}” field already exists with a different type ({type})',
  // Настройки подключения Автокрафта: поле ссылки на проект
  'Ссылка на проект Автокрафта': 'Autocraft project link',
  'Ключ ({key}) не показывается — он хранится зашифрованным. Чтобы сменить проект или перевыпущенный ключ, вставьте ссылку из Автокрафта целиком, вместе с ним.':
    'The key ({key}) is not shown — it is stored encrypted. To change the project or a reissued key, paste the full link from Autocraft, including the key.',
  'Ссылка обновлена, генераторов: {count}': 'Link updated, generators: {count}',
  'Сохранить ссылку': 'Save link',
  // Переменные шаблона названия указателя (packages/shared)
  'Код типа': 'Type code',
  'Номер плана': 'Plan number',
  'Номер указателя': 'Sign number',
  // Публичная карта: комментарии
  'Комментарий...': 'Comment...',
  'Ваше имя': 'Your name',
  'Отправить': 'Send',
  'Редактировать': 'Edit',
  'В архив': 'Archive',
  'Реакция на карте': 'Reaction on the map',
  'Редактировать ответ': 'Edit reply',
  'Ответ…': 'Reply…',
  'Ответ': 'Reply',
  'Отправить ответ': 'Send reply',
  'Не удалось загрузить комментарии на карте': 'Could not load map comments',
  'Не удалось отправить комментарий': 'Could not send the comment',
  'Нравится': 'Like',
  'Сердце': 'Heart',
  'Звезда': 'Star',
  'Злость': 'Angry',
  'Грусть': 'Sad',
  'Разбитое сердце': 'Broken heart',
  'Какашка': 'Poop',
  'только что': 'just now',
  '1 минуту назад': '1 minute ago',
  'недавно': 'recently',
  'час назад': '1 hour ago',
  '2 часа назад': '2 hours ago',
  '1 день назад': '1 day ago',
  // Публичная карта: карточка объекта, список мест, фильтры
  'Скопировать координаты': 'Copy coordinates',
  'Скопировано': 'Copied',
  'Скопировать ссылку': 'Copy link',
  'Закрыть просмотр': 'Close preview',
  'Увеличить: {label}': 'Enlarge: {label}',
  'Встроенный проигрыватель ({provider})': 'Embedded player ({provider})',
  'Оставить комментарий': 'Leave a comment',
  'Поставить комментарий': 'Add a comment',
  'Выключить режим комментариев': 'Turn off comment mode',
  'Комментарии на карте': 'Map comments',
  'Поиск по местам': 'Search places',
  'На карте пока нет мест': 'There are no places on the map yet',
  'Нет данных для фильтра': 'No data for the filter',
  'Не указано': 'Not specified',
  'Нет числовых значений для таймлайна': 'No numeric values for the timeline',
  'Загрузка гистограммы…': 'Loading histogram…',
  'Свернуть панель': 'Collapse panel',
  'Развернуть панель': 'Expand panel',
  // Настройки просмотра: язык публичной карты
  'Язык карты и интерфейса': 'Map and interface language',
  'Авто — язык посетителя. Русский и English закрепляют язык подписей карты, лого и интерфейса, в том числе в презентации.': 'Auto follows the visitor’s language. Russian and English fix the language of map labels, the logo and the interface, including in the presentation.',
  // Публичная карта: ошибка загрузки
  'Карта не найдена': 'Map not found',
  'Возможно, карты не существует или ссылка устарела.': 'This map may not exist or the link may have expired.',
  // Плеер презентаций (публичная страница)
  'Презентация недоступна': 'Presentation unavailable',
  'Возможно, её сняли с публикации или ссылка устарела.': 'It may have been unpublished, or the link is out of date.',
  'В презентации пока нет слайдов': 'This presentation has no slides yet',
  'Слайд {number}': 'Slide {number}',
  'Предыдущий слайд': 'Previous slide',
  'Следующий слайд': 'Next slide',
  'Вернуться к истории': 'Back to the story',
  'Исследовать карту': 'Explore the map',
  // Ошибки запросов к API
  'Сессия истекла': 'Session expired',
  'Ошибка авторизации': 'Authorization error',
  'Ошибка запроса': 'Request error',
};

export function editorText(
  source: string,
  params?: Record<string, string | number>,
): string {
  // Тот же источник, что у провайдера: иначе при языке «по браузеру» `et()` отдавал бы
  // английский, а `editorText()` — русский.
  const template = getCurrentLanguage() === 'en' ? (editorTranslationsEn[source] ?? source) : source;
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    Object.hasOwn(params, name) ? String(params[name]) : match,
  );
}
